import React, { useState, useEffect } from 'react'
import InputField from '../UI/Input/InputField';
import ButtonField from '../UI/Button/ButtonModalField';
import { Row, Col , Modal } from 'react-bootstrap';
import useValidator from '../../hooks/useValidator';
import { PostAPI } from '../../api/post';
import { useTranslation } from 'react-i18next';
import { FetchAPI } from '../../api/fetch';
import { Domain } from "environment/environment";
import swal from 'sweetalert';
import BeatLoader from "react-spinners/BeatLoader";
import Toggle from "react-toggle";
import MultiFileUpload  from "components/MultiFileUpload/MultiFileUpload";
import FileUpload from "components/SingleFileUpload/FileUpload"
import FileList from "components/FileList/FileList";
import MultiFileList from "components/MultiFileList/MultiFileList"
import "react-toggle/style.css"
import { isEmpty } from 'components/Login/validator';
import { Table } from "react-bootstrap";
import moment from 'moment';
import Cookies from 'universal-cookie';
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
// import { ContactSupportOutlined } from '@material-ui/icons';
import globaldata from "../../../src/constants/globaldata.json";
import DragAndDrop from '../DragAndDrop/DragAndDrop';
import { getStatusAlert } from '../../utilities/CommonUtils';
import CustomSwitch from 'components/CustomSwitch/CustomSwitch';
import {handleNetworkErrors} from "../../utilities/CommonUtils"
import CustomFields from '../CustomFields/CustomFields';

const cookies = new Cookies();
let urlhost = window.location.host;
let urlprotocol = window.location.protocol;
let completeURL = urlprotocol + "//" +urlhost;

const ModalBox = ( props ) => {
    const root = document.documentElement;
    const buttonBackgroundColor = getComputedStyle(root).getPropertyValue('--button_background-color').trim();
    const buttonTextColor = getComputedStyle(root).getPropertyValue('--button_text-color').trim();
    const { setHasError } = props;
    const { t, i18n } = useTranslation();
    let[reason, setReason] = useState();
    let [editFileUpload, setEditFileUpload] = useState()
    const [selectedType, setSelectedType] = useState(null);
    let [tableList, setTableList] = useState([]);
    let [buLocations, setBuLocations] = useState([]);
    let [unique, setUnique] = useState([]);
    let [toggle,setToggle] = useState()
    let [unBind,setUnbind] = useState({
        delimiter : 'multiline',
        toggle : false
    })
    let [tdData, setTdData] = useState([]);
    let [disabled, setDisabled] = useState(false);
    let [material, setMaterial] = useState();
    let [buttonOverlap, setButtonOverlap] = useState(false)
    let [disabledOnCheck, setDisabledOnCheck] = useState({
        transaction:false,
        whiteList:false
    });
    let [po_Number, setPO_number] = useState([]);
    let [parentTableLength, setParentTableLength] = useState();
    let [releaseNotes, setReleaseNotes] = useState();
    let [formFile, setFormFile] = useState();
    let [qty, setQty] = useState();
    const [lat, setLat] = useState();
    const [lan, setLan] = useState();
    const[modifiedArray, setModifiedArray] = useState([])
    const [dynamicParam, setDynamicParams] = useState({})
    let [doclinks, setDocLinks] = useState();
    let [quantity, setQuantity] = useState();
    let [product, setProduct] = useState();
    const [sequence, setSequence] = useState();
    let [transaction, setTransaction] = useState();
    let [location, setLocation] = useState();
    let [buildUrl, setBuildUrl] = useState();
    let [docUrl,setDocUrl] = useState([]);
    let [unBindValue,setUnBindValue] = useState('')
    let [edit, setEdit] = useState(false)
    let [editProp,setEditProp]=useState(false)
    let [docEdit, setDocEdit] = useState(null)
    let [drpdwnResponse, setDrpDwnResponse] = useState()
    let [buildEdit, setBuildEdit] = useState(null)
    let [formInputs, setFormInputs] = useState();
    let [form, setForm] = useState();
    let [productgroup, setProductgroup] = useState();
    const [readonly, setReadOnly] = useState(false);
    let [price, setPrice] = useState();
    let [remarks, setRemarks] = useState();
    let [visible, setVisible] = useState(false);
    const [validator, showValidationMessage] = useValidator();
    const initialValue = [{displayValue: `${t('please_select')}`, value: ''}];
    let [center, setCenter] = useState({
        lat: 0, 
        lng: 0
    })
    let uniq;
    let data;
    let [selectedFile, setSelectedFile] = useState();
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [area, setArea] = useState('');
	const [state, setState] = useState('');
    const [country, setCountry] = useState('');
    const [mapPosition, setMapPosition] = useState({
        lat: center.lat,
        lng: center.lng
	});
	const  [markerPosition, setMarkerPosition] = useState({
        lat: center.lat,
        lng: center.lng
    });
    let [passVal, setPassVal] = useState();
    let [fromDate, setFromDate] = useState();
    let [toDate, setToDate] = useState();
    let [staticModalformValues, setStaticModalformValues] = useState(props.buildValue);
    const [uploadFiles, setUploadFiles] = useState([])
    const [multiUploadFiles, setMultiUploadFiles] = useState([])
    let [ModalformValues, setModalformValues] = useState(props.formValue);
    const [buildInputVal,setBuildInputVal] = useState({})
    const [checked,setChecked]= useState(false)
    const [cloneformValues, setCloneFormValues] = useState({})
    let [loadSForm, setloadSForm] = useState(false);
    let filteredData;
    const [productTransactionTableList, setProductTransactionTableList] = useState([])
    const [uniqueData, setUniqueData] = useState()
    let [disabledButton, setDisabledButton] = useState(false);
    let[loading,setLoading]=useState(false);
    const [selectElements, setSelectElements] = useState(null);
    const [selectedElements, setSelectedElements] = useState(null);
    const [dropdownApiData, setDropdownApiData] = useState(null);
    const [customFormData, setCustomFormData] = useState({
        label: "",
        fieldName: "",
        fieldType: "",
        optionsField: "",
        validationRule: "",
        regex: "",
        regexMessage: "",
        isRequired: false,
        showColumn: false,
        duplicateOptions: [],
        selectedOptions: [{
            displayValue: "Please Select",
            value: null
        }]
    })
    const [rule, setRule] = useState("");

    let commonval = '';
    let customerID = ['13','14','15']
    const titlesList = ['UnBind Serial Number','Assign Serial Number']
    let centeredDiv = {
        display: 'flex',
        borderRadius: '15px',
        fontSize: '9px',
        position:'relative',
        alignItems: 'center',
    }
    let commonParams = {
        customer_id:cookies.get('customer_id'),
        user_id:cookies.get('user_id'),
        userRole_name:cookies.get("userRole_name"),
        language:localStorage.getItem('i18nextLng') === 'en' ? 'english' : 'chinese',
        userLocation_id: cookies.get("userLocation_id")
    }
    
    const cromptonAssignIot = (cookies.get("customer_id") === "17" && props.commonTitle === "Assign IOT")
    const cromptonDownloadIot = (cookies.get("customer_id") === "17" && props.commonTitle === "Download IOT")
    const cromptonDelivery = (cookies.get("customer_id") === "17" && props.title === "Delivery");
    const formElementsArray = [];
    for (let key in ModalformValues){
      formElementsArray.push({
        id: key,
        config: ModalformValues[key]
      });
    }
    const removeFile = (filename,type) => {
        try{
        if (props.titlePreFix == 'Edit') {
            if(type == "doc"){
                setDocEdit(0)
            }
            if(type == "build"){
                setBuildEdit(0)
            }
            setEditProp(true)
            if(doclinks){
                setDocLinks(doclinks.filter((link) => decodeURIComponent(link.file).substring(decodeURIComponent(link.file).lastIndexOf('/') + 1) !== filename))
            }
            if(buildUrl){
                setBuildUrl(buildUrl.filter(file => file.name !== filename))
            }
            setDocUrl(docUrl.filter(file => file.name !== filename))
        } else {
            setUploadFiles(uploadFiles.filter(file => file.name !== filename))
            setMultiUploadFiles(multiUploadFiles.filter(file => file.name !== filename))

        }
    } catch(error){
        setHasError({
            error: true,
            message: error
          })
    }
    }
    const customModalFields = (formElementsArray) => {
        try{
        switch (props.title) {
            case 'UnBind Serial Number':
                return (
                    <>
                        {formElementsArray.map(formElement => (
                       <>
                       <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                           <div style={{ flex: '1', minWidth: '200px' }} key={formElement.id}>
                               <label className="Label" htmlFor="lang">
                                   Delimiter/Seperator
                                   <span style={{ color: "red", fontSize: '16px' }}>*</span>
                               </label>
                               <select
                                   className="form-control"
                                   id="lang"
                                   onChange={(e) => {
                                       let newValue = e.target.value;
                                       if (newValue) {
                                           setUnbind((prevState) => ({ ...prevState, delimiter: newValue }));
                                       }
                                   }}
                                   value={unBind.delimiter}
                               >
                                   <option value="mulitiLine">NewLine</option>
                                   <option value="comma">Comma(,)</option>
                               </select>
                           </div>
                   
                           <div style={{ flex: '1', minWidth: '200px' }}>
                               <span style={{ display: 'flex', alignItems: 'center'}}>
                                   Master Carton &nbsp;
                                   <CustomSwitch
                                       changed={() =>
                                           setUnbind((prevState) => {
                                               return {
                                                   ...prevState,
                                                   toggle: !prevState.toggle,
                                               };
                                           })
                                       }
                                       checked={unBind.toggle}
                                   >
                                       Unind
                                   </CustomSwitch>
                                   &nbsp; Gift Box
                               </span>
                           </div>
                       </div>
                   
                       <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                           <div className="grid-item" style={{ flex: '1', minWidth: '200px' }}>
                               <InputField
                                   key={formElement.id}
                                   elementType={formElement.config.elementType}
                                   elementConfig={formElement.config.elementConfig}
                                   value={unBindValue}
                                   labelName={formElement.config.label}
                                   id={formElement.config.id}
                                   isValidate={formElement.config.validate}
                                   changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                   validater={validator}
                                   titlePreFix={props.titlePreFix}
                                   title={props.title}
                                   setHasError={setHasError}
                               />
                           </div>
                       </div>
                   </>
                        ))}
                        {/* <div className="button-container" style={{justifyContent:'flex-end',transform:'translateY(3rem)'}}>
                            <button onClick={clearUnBindValue} class="button-danger" 
                            >{t("clear")}</button>
                            <button disabled={disabled} class="button-styles" onClick={submitForm} 
                            >{t('submit')}</button>
                        </div> */}
                    </>
                );
            case 'Assign Serial Number':
                return (
                    <>
                        {formElementsArray.map(formElement => (
                        <div className="grid-item"
                            key={formElement.id}>
                            <InputField
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={(formElement.config.value == null) ? '' : formElement.config.value}
                                labelName={formElement.config.label}
                                id={formElement.config.id}
                                isValidate={formElement.config.validate}
                                changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                validater={validator}
                                titlePreFix={props.titlePreFix}
                                title={props.title}
                                template={props.dyn_template}
                                passVal={passVal}
                                setPassVal={setPassVal}
                                tableList={tableList}
                                material={material}
                                setMaterial={setMaterial}
                                qty={qty}
                                setQty={setQty}
                                quantity={quantity}
                                setQuantity={setQuantity}
                                product={product}
                                setProduct={setProduct}
                                setHasError={setHasError}
                            />
                        </div>
                        ))}
                    </>
                )
        }
    }catch(error){
        setHasError({
            error: true,
            message: error
          })
    }
    }

    const alertMessage =(msg)=>{
        try{
        let errorMessage;
        function containsNumber(str) {
            return /[0-9]/.test(str);
            }

        if (containsNumber(msg)) {
           const count = msg.match(/\d+/g); // [50, 455]
           let extractedWords = msg.match(/\D+/g); 
            let message = "";
          extractedWords.map((words,index)=>{
           let countValue =count.map((c)=>{
         return c
             })[index]
           message = message.concat(" ",t(words.trim())," ", countValue??'') 
                // return words
 })
            errorMessage= message
  // errorMessage = t(extractedWords[0])+ count[0] + t(extractedWords[1]) + count[1]  + t(extractedWords[2])+ count[2]  ;
           }
        else{
            errorMessage= t(msg)
            
        }
        swal(errorMessage, {
            icon: "error",
            button:`${t("alerts.ok")}`
            // timer: 2000,
            // button: false
            });
        }catch(error){
            setHasError({
                error: true,
                message: error
              })
        }
    }
   
    const addTableData = (upd) => {
      try{
        setCloneFormValues(JSON.parse(JSON.stringify(upd)))
        const someProperty = {...upd}
        if(props.commonTitle === 'Product Transaction' && tdData?.transaction === undefined){
          swal({title: 'Choose valid Transaction', text: 'Please select the Transaction to add the table', icon:"warning", button:`${t("alerts.ok")}`})
        }
        if((tdData['material'] && tdData['material'] ===  `${t('please_select')}`)){
          swal({title:`${t("alerts.choose_valid")}`, text:`${t("alerts.please_cannot_be_selected")}`, icon:"warning", button:`${t("alerts.ok")}`})
        }
    if(validator.allValid()) {
        Object.keys(someProperty).forEach(el => {
            if (((el === 'material' || el === 'qty') && (someProperty["material"]?.update?.endPoint === undefined && cookies.get('customer_id') !== '13'))|| (props.commonTitle !== "Product Transaction") &&  el === 'location' || el === 'product_group' || el === "transactions" || (props.title === "Purchase Order" && el === "product")){
                someProperty[el].value = '';
            }
            else if((props.commonTitle === "Download IOT's(Buffer)" || props.commonTitle === 'Reclamation Delivery') && (el === "material" || el === "qty")){
                someProperty[el].value = '';
            }
            else if(props.commonTitle === "Product Transaction"){
                if(el === 'transaction' || el === 'sequence'){
                    someProperty[el].value = '';
                }
            }
            else if((props?.permission === false && props.commonTitle === 'Delivery' && someProperty["material"].update?.endPoint !== undefined && (cookies.get('customer_id') === '13' || cookies.get('customer_id') === '16' || cookies.get('customer_id') === '19') && (el === 'material' || el === 'qty'))){
            someProperty[el].value = '';
            }
            else if(props.commonTitle === "BOM Mapping" && (el == "product_id" || el === "qty" || el === "bom_id")){
                if(props.titlePreFix === "Edit"){
                    if(el !== "product_id"){
                        someProperty[el].value = '';
                    }
                }else{
                    someProperty[el].value = '';
                }
            }
        })
        if(props.title!='Buffer Serial Number'){
            Object.keys(someProperty).forEach(el => {
                if(el === 'material' || el === 'qty' || el === 'location' || el === 'product_group'){
                if((props.title === "Delivery" && typeof(someProperty['material'].value) === 'string' && tdData.material === undefined)){
                    swal(`${t("Add Values")}`, `${t("Please select a material to add table")}`, "warning")
                }else if(props.title === 'AttributeSets' && Boolean(!tdData['product_group']))
                    swal(`${t("Add Values")}`, `${t("Please select a product group to add table")}`, "warning")
                }
            })
            // Object.keys(someProperty).map(el => {
            //     if((el === 'Primary - Gift Box Quantity') || (el === 'product')){
            //     if(props.title === "Assign Serial Number" && typeof(someProperty['product'].value) === 'string') {
            //             swal("Add Values", "Please select a product to add table", "warning")
            //         }
            //     else if(props.title === "Assign Serial Number" && typeof(someProperty['product'].value) === 'string' || someProperty['Primary - Gift Box Quantity'].value == ""){
            //         swal("Add Values", "Please update the quantity to add table", "warning")
            //     }
            // }
            // })

        }

        if (props.commonTitle === "AttributeSets") {
            for (var i = 0; i < tableList.length; i++) {
                if (tableList[i].product_group == tdData.product_group
                    && tableList[i].location == tdData.location && tableList[i].transactions == tdData.transactions) {
                    swal({ title: `${t("alerts.duplicate_values")}`, text: `${t("alerts.already_assigned_to_location")}`, icon: "error", button: `${t("alerts.ok")}` })
                    return;
                }
            }
            setTdData([]);
        }
        if (props.commonTitle === "Purchase Order") {
            for (var i = 0; i < tableList.length; i++) {
                if (tableList[i].product == tdData.product) {
                    swal({ title: `${t("alerts.duplicate_values")}`, text: `product is already assigned to location`, icon: "error", button: `${t("alerts.ok")}` })
                    return;
                }
            }
            setTdData([]);
        }

        if (props.commonTitle === "BOM Mapping") {
            for (var i = 0; i < tableList.length; i++) {
                if (tableList[i].product_id == tdData.product_id || props.titlePreFix === "Edit") {
                    if(tableList[i].bom_id === tdData.bom_id){
                        swal({ title: `${t("alerts.duplicate_values")}`, text: `${tdData.bom_id} is already assigned to ${tableList[i].product_id}`, icon: "error", button: `${t("alerts.ok")}` })
                        return;
                    }
                }
            }
            setTdData([]);
        }

        if(props.commonTitle === "Reclamation Delivery"){
            if(tableList.length == 0){
                setReadOnly(true)
            }else{
                setReadOnly(false)
            }
            Object.keys(someProperty).forEach(el => {
                if((el === 'material' && someProperty[el].update.required == true )){
                    if(tableList.length !== 0 && someProperty['material'].value !== null){
                        if(tdData['material'] === undefined || tdData['qty'] === undefined){
                         addTableAlerts(someProperty, tdData)
                        }
                    }
                }
            })
        }
        if(props.commonTitle === "Download IOT's(Buffer)") {
            for(var i = 0; i < tableList.length; i++) {
                if (tableList[i].po_number == tdData.po_number
                    && tableList[i].material == tdData.material) {
                swal({title:`${t("alerts.duplicate_values")}`, text:`${t("alerts.already_assigned_to_material")}`, icon:"error", button:`${t("alerts.ok")}`})
                        setTdData([])
                    }
                }
        }
            if(props.commonTitle === 'Pick List') {
                Object.keys(someProperty).forEach(el => {
                    if((el === 'deliveries') || (el === 'from_location'))
                    if(someProperty[el].elementType === 'multiselect') {
                        if((someProperty[el].value)) {
                            let arrayConvert = [];
                            someProperty[el].value.map(function(fValue, indexId){
                                arrayConvert[indexId] = fValue.value;
                            tdData[el] = arrayConvert
                            });
                        }
                    }
                    if(el === 'deliveries' && someProperty[el].update.required == true){
                        if(tableList.length == 0){
                            let getURL = someProperty[el].update.endPoint;
                            updateEndPoint(getURL, tdData);
                        }
                        else {
                            const deliveryArray = [];
                            tableList.forEach(ele => {
                                if (deliveryArray.indexOf(ele.delivery_no) === -1) {
                                    deliveryArray.push(ele.delivery_no)
                                }
                            })
                            if( deliveryArray.length === tdData['deliveries'].length && 
                            deliveryArray.every(item => tdData['deliveries'].indexOf(item) > -1))
                                console.log("@@matched");
                            else {
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData);
                            }
                        }
                    }
                })
            }
            if(props.commonTitle === "Vendor Serial Number" || props.commonTitle === 'Reclamation PO'){
                Object.keys(someProperty).forEach(el => {
                    if((el === 'po_number'))
                        if((someProperty[el].value)) {
                            let arrayConvert = [];
                            arrayConvert.push(someProperty[el].value)
                            tdData[el] = arrayConvert
                        }
                        
                    })
                    Object.keys(someProperty).forEach(el => {
                        if((el === 'po_number' && someProperty[el].update.required == true )){
                            if(tableList.length == 0){
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData, someProperty);
                            }
                        }
                    //         else {
                    //             const prodArray = [];
                    //             tableList.map(ele => {
                    //                 if (prodArray.indexOf(ele.po_number) === -1) {
                    //                     prodArray.push(ele.po_number)
                    //                 }
                    //             })
                    //             if(prodArray.some(item => tdData['po_number'].includes(item)))
                    //             swal("Already product added", "Duplicate values not allowed", "warning");
                    //             else {
                    //                 let getURL = someProperty[el].update.endPoint;
                    //                 updateEndPoint(getURL, tdData, someProperty);
    
                    //             }
                    //         }
                    //     }
                    })
                    setDisabled(true)
            }
            if(props.commonTitle === "Revert Assigned Serial Number") {
                // for setting data in tdData
                Object.keys(someProperty).forEach(el => {
                    if ((el === 'po_number') || (el === 'product') || (el === 'Quantity'))
                        if (someProperty[el].elementType === 'input' || someProperty[el].elementType === 'selectshowsearch') {
                            if ((someProperty[el].value)) {
                                let arrayConvert = [];
                                arrayConvert.push(someProperty[el].value)
                                tdData[el] = arrayConvert
                            }
                        }
                    })
                // to make api call
                Object.keys(someProperty).forEach(el => {
                    if((el === 'product' && someProperty[el].update.required == true )){
                    if(tableList.length == 0 && someProperty['product'].value !== null){
                      let getURL = someProperty[el].update.endPoint;
                        updateEndPoint(getURL, tdData, someProperty);
                        
                    }else if(tdData['product'] === undefined || tdData['Quantity'] === undefined){
                        addTableAlerts(someProperty, tdData)
                    }else if(tableList.length !== 0 && tdData['product'] !== undefined){
                        // Handling the dublicate values;
                        const prodArray = [];
                        const tbData = []
                        let data = Array.from(tdData['product'])
                        data.forEach((fvalue,indexId) => {
                            tbData[indexId] = fvalue.label
                        })
                        tableList= tableList.filter((e)=>e!=undefined||e!=null)
                        tableList.forEach(ele => {
                            if (prodArray.indexOf(ele.product) === -1) {
                                prodArray.push(ele.product)
                            }
                        })
                        if(prodArray.some(item => tbData.includes(item))){
                            swal({title:`${t("alerts.already_product")}`, text:`${t("alerts.duplicate_not_allowed")}`, icon:"warning", button:`${t("alerts.ok")}`})
                        }
                    else {
                            let getURL = someProperty[el].update.endPoint;
                            updateEndPoint(getURL, tdData, someProperty);
                        }
                    }
                    }
                });
            }
            if(props.commonTitle === "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") {
                Object.keys(someProperty).forEach(el => {
                if((el === 'Primary - Gift Box Quantity') || (el === 'product')){
                    if((someProperty[el].value)) {
                        let arrayConvert = [];
                        arrayConvert.push(someProperty[el].value)
                        tdData[el] = arrayConvert
                    }
                }   
                })
                Object.keys(someProperty).forEach(el => {
                    if((el === 'product' && someProperty[el].update.required == true )){
                        if(tableList.length == 0 && someProperty['product'].value !== null){
                            let getURL = someProperty[el].update.endPoint;
                            if(props.commonTitle === 'Assign Serial Number'){
                                ModalformValues['po_mode'].elementConfig.readonly = true
                            }
                            updateEndPoint(getURL, tdData, someProperty);
                        }
                        else if(tdData['product'] === undefined || tdData['Primary - Gift Box Quantity'] === undefined){
                            addTableAlerts(someProperty, tdData)
                        }
                        else if(tableList.length !== 0 && tdData['Primary - Gift Box Quantity'] !== undefined && tdData['product'] !== undefined ){
                            const prodArray = [];
                            const tbData = []
                            let data = Array.from(tdData['product'])
                            data.forEach((fvalue,indexId) => {
                                tbData[indexId] = fvalue.label
                            })
                            tableList.map(ele => {
                                if (prodArray.indexOf(ele.product) === -1) {
                                    prodArray.push(ele.product)
                                }
                            })
                            if(prodArray.some(item => tbData.includes(item))){
                                swal({title:`${t("alerts.already_product")}`, text:`${t("alerts.duplicate_not_allowed")}`, icon:"warning", button:`${t("alerts.ok")}`})
                            }
                        else {
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData, someProperty);
                            }
                        }
                    }
                })
            }
            
            if(props.commonTitle === "Buffer Serial Number") {
                Object.keys(someProperty).forEach(el => {
                     if(el==="product"||el==="Quantity"){
                        tdData[el]= [someProperty[el].value]
                     }
                     if(el=="vendorId"){
                        tdData[el]= someProperty[el].value.value                     }
            })
            Object.keys(someProperty).forEach(el => {
                if(el=="use_type" && tableList.length > 0){
                    let getURL = someProperty[el].update.endPoint;
                        const test = po_Number.filter(item => item === po_Number[0])
                        if(Boolean(someProperty['product'].value) == 0 || JSON.stringify(tdData['Quantity']) === JSON.stringify([''])){
                            addTableAlerts(someProperty, tdData)
                        }else if(test[0] === ModalformValues['po_number'].value.value){
                                updateEndPoint(getURL, tdData, someProperty);
                            }else{
                                const span = document.createElement("span");
                                span.innerHTML = `Alert: Previous PO : <code>${test[0]}</code> is different from Selected PO :\n <code>${ModalformValues['po_number'].value.value}</code>`                                    
                                swal({
                                        html: true,
                                        title : 'Distinct PO cannot be added',
                                        content: span,
                                        icon: "info",
                                        dangerMode: true,
                                    })
                            }
                }
            })
            Object.keys(someProperty).forEach(el => {
                if((el === 'Primary - Gift Box Quantity') || (el === 'use_type')){
                    if(tableList.length !== 0){
                        const prodArray = [];
                        const tbData = []
                        let data = Array.from(tdData['product'])
                        // tableList.m                        
                        data.forEach((fvalue,indexId) => {
                            tbData[indexId] = fvalue?.label                        })
                        tableList.forEach(ele => {
                            if (prodArray.indexOf(ele.product) === -1) {
                                prodArray.push(ele.product)
                            }
                        })
                        if(prodArray.some(item => tbData.includes(item))){
                            swal({ title: `${t("alerts.already_material")}`, text: `${t("alerts.duplicate_not_allowed")}`, icon: "warning", button: `${t("alerts.ok")}` });
                        }
                    }
                    else{
                        let getURL = someProperty[el].update.endPoint;
                       updateEndPoint(getURL, tdData, someProperty);
                    }
            }
        })
    }
            if((props?.permission === true && (cookies.get('customer_id') == '13' || cookies.get('customer_id') == '19' || cookies.get('customer_id') == '16')) || (props.commonTitle === 'Delivery' && someProperty["material"].update?.endPoint !== undefined && (cookies.get('customer_id') !== '13' && cookies.get('customer_id') !== '16' && cookies.get('customer_id') !== '19'))) {
                let stopAddTable = false;
                Object.keys(someProperty).forEach(el => {
                    if((el === 'material')){
                        if((someProperty[el].value)) {
                            let arrayConvert = [];
                            arrayConvert.push(someProperty['material'].value)
                            tdData[el] = arrayConvert
                            tdData["qty"] = someProperty['qty'].value
                            if(cookies.get("customer_id") == 17){
                                tdData["po_number"] = someProperty["po_number"].value?.value;
                                tdData["to_location"] = someProperty["to_location"]?.elementConfig?.options[0]?.displayValue
                            }
                        }
                    }
                    })
                if(cookies.get("customer_id") === "17" && props.title === "Delivery"){
                    if(tableList?.length > 0){
                        for(let list of tableList){
                            if((list.to_location !== someProperty.to_location.elementConfig.options[0].displayValue) || (list.from_location !== someProperty.from_location.elementConfig.options[0].displayValue)){
                                stopAddTable = true; 
                            }
                        }
                    }
                }
                    if(stopAddTable){
                        swal("Selected PO source and destination locations should match with table materials")
                        return;
                    }
                    Object.keys(someProperty).forEach(el => {
                        if((el === 'material' && someProperty[el].update.required == true )){
                            if(tableList.length == 0 && someProperty['material'].value !== null){
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData, someProperty);
                            }
                            else if(tdData['material'] === undefined || tdData['qty'] === undefined){
                                addTableAlerts(someProperty, tdData)
                            }
                            else if(tableList.length !== 0 && tdData.material !== undefined) {
                                const matArray = [];
                                const tbData = [];
                                const poNumbers = []
                                let stopIteration = false;
                                let deliveryFlag = true;
                                let data = Array.from(tdData['material'])
                                data.forEach((fvalue,indexId) => {
                                    tbData[indexId] = fvalue.label
                                })
                                tableList.forEach(ele => {
                                    if(ele.po_number)
                                    if (matArray.indexOf(ele.material) === -1) {
                                        matArray.push(ele.material)
                                        poNumbers.push(ele.po_number)
                                    }
                                })
                                for (let item of tableList) {
                                    if (item.po_number !== tdData["po_number"]) {
                                        deliveryFlag = false;
                                    } else {
                                        if (matArray.some(item => tbData.includes(item))) {
                                            stopIteration = true;
                                            deliveryFlag = false;
                                            swal({ title: `${t("alerts.already_material")}`, text: `${t("alerts.duplicate_not_allowed")}`, icon: "warning", button: `${t("alerts.ok")}` })
                                            break;
                                        }
                                    }
                                }
                                if(stopIteration){
                                    return;
                                }
                                if(matArray.some(item => tbData.includes(item)) && deliveryFlag){
                                swal({title:`${t("alerts.already_material")}`, text:`${t("alerts.duplicate_not_allowed")}`, icon:"warning", button:`${t("alerts.ok")}`})        
                                }
                            else {
                                    let getURL = someProperty[el].update.endPoint;
                                    updateEndPoint(getURL, tdData, someProperty);
                                }
                            }
                        }
                    })
            }
            //     if( props.commonTitle === "Product Transaction") {
            //         Object.keys(someProperty).map(el => {
            //             if((el === 'transaction') || (el === 'sequence')){
            //                 if((someProperty[el].value)) {
            //                     let arrayConvert = [];
            //                     arrayConvert.push(tdData[el])
            //                     tdData[el] = arrayConvert
            //             }
            //         }
            //         })
            //         // Object.keys(someProperty).map(el => {
            //         //     if((el === 'transaction' && someProperty[el].update.required == true )){
            //         //         if(tableList.length == 0 && someProperty['transaction'].value !== null){
            //         //             let getURL = someProperty[el].update.endPoint;
            //         //             updateEndPoint(getURL, tdData, someProperty);
            //         //         }
            //         //         else if(tableList.length !== 0 && tdData.transaction !== undefined) {
            //         //             const matArray = [];
            //         //             const tbData = []
            //         //             let data = Array.from(tdData['transaction'])
            //         //             data.map((fvalue,indexId) => {
            //         //                 tbData[indexId] = fvalue.label
            //         //             })
            //         //             tableList.map(ele => {
            //         //                 if (matArray.indexOf(ele.transaction) === -1) {
            //         //                     matArray.push(ele.transaction)
            //         //                 }
            //         //             })
            //         //             if(matArray.some(item => tbData.includes(item))){
            //         //                 swal("Already transaction added", "Duplicate values not allowed", "warning");
            //         //             }
            //         //         else {
            //         //                 let getURL = someProperty[el].update.endPoint;
            //         //                 updateEndPoint(getURL, tdData, someProperty);
            //         //             }
            //         //         }
            //         //     }
            //         // })
            // }

            // if( props.commonTitle === "Download IOT's(Buffer)" && someProperty["material"].update?.endPoint !== undefined) {
            //     Object.keys(someProperty).map(el => {
            //         if((el === 'material') || (el === 'po_number') || (el === "qty")){
            //             if((someProperty[el].value)) {
            //                 let arrayConvert = [];
            //                 arrayConvert.push(someProperty['material'].value)
            //                 tdData[el] = arrayConvert
            //                 tdData["qty"] = someProperty['qty'].value
            //                 tdData["po_number"] = someProperty['po_number'].value
            //             }
            //         }
            //         })
            //         Object.keys(someProperty).map(el => {
            //             if((el === 'material' && someProperty[el].update.required == true )){
            //                 if(tableList.length == 0 && someProperty['material'].value !== null){
            //                     let getURL = someProperty[el].update.endPoint;
            //                     updateEndPoint(getURL, tdData, someProperty);
            //                 }
            //                 else if(tableList.length !== 0 && tdData.material !== undefined) {
            //                     const matArray = [];
            //                     const tbData = []
            //                     let data = Array.from(tdData['material'])
            //                     data.map((fvalue,indexId) => {
            //                         tbData[indexId] = fvalue.label
            //                     })
            //                     tableList.map(ele => {
            //                         if (matArray.indexOf(ele.material) === -1) {
            //                             matArray.push(ele.material)
            //                         }
            //                     })
            //                     if(matArray.some(item => tbData.includes(item))){
            //                         swal("Already material added", "Duplicate values not allowed", "warning");
            //                     }
            //                 else {
            //                         let getURL = someProperty[el].update.endPoint;
            //                         updateEndPoint(getURL, tdData, someProperty);
            //                     }
            //                 }
            //             }
            //         })
            // }
            if(Boolean(tdData['product_group'])){
            setTableList((tableList) => tableList.concat(tdData));
            }else if(props.commonTitle === "AttributeSet" && cookies.get("customer_id") == 12){
                setTableList(tdData)
            }else if(props.commonTitle === "BOM Mapping"){
                if(tdData.bom_id && tdData.qty){
                        const obj = {
                            ...tdData,
                            ...(props.titlePreFix === "Edit"? {product_id: tableList[0].product_id,prod_id: tableList[0].prod_id }: {})
                        }
                    setTableList((tableList) => tableList.concat(obj));
                }else{
                    swal("Error", "Please fill all the fields", "error");
                }
                return;
            }
            else if(props.commonTitle !== "AttributeSets"){
                setTableList((tableList) => tableList.concat(tdData));
                setProductTransactionTableList((productTransactionTableList) => productTransactionTableList.concat(modifiedArray));
            }
        // setTdData([])
    } 
    else{
        showValidationMessage(true);
    }
        }catch(error){
            setHasError({
                error: true,
                message: error
              }) 
        }
    }

    useEffect(() => {
      try{
        let QCpayload = {};      
        if((props.title === 'QC Params' || props.title === 'QC Attributes') && formInputs){
            for (let [key,value] of Object.entries(formInputs)){
                let valueToAssign = value.value
                if (key === 'qc_params') {
                    valueToAssign = value.label;
                }
                if(Array.isArray(value)){
                    value.forEach((fvalue,indexId) => {
                            valueToAssign = fvalue.value
                            if (key === 'qc_params') {
                                valueToAssign = fvalue.label;
                            }
                    })
                }
                QCpayload[key] = valueToAssign
                setDynamicParams({...QCpayload})
            }
        }
        }catch(error){
            setHasError({
                error: true,
                message: error
            })
        }
    },[props.title, formInputs])
   
    function getKeysYML(){
        if(props.headers !== null)
            return Object.values(props.headers);
        }

        function getHeader() {
            let keys = getKeysYML();
            let headers = keys.map((key) => {
                return i18n.language === "chi"
                    ? <th key={key}>{key["text"].toUpperCase()}</th>
                    : <th key={key}>{key.replace(/_/g, " ").toUpperCase()}</th>;
            });
            headers.push(props.commonTitle !== "Vendor Serial Number" || props.commonTitle !== "Reclamation PO" ? 
            <th colspan="3" ></th>
             : '');
            return headers;
        } 
    
    function addTableAlerts(someProperty, tableData) {
      try{
        let title, text;
        switch (props.commonTitle) {
            case 'Assign Serial Number':
            case 'Reclamation Assign PO':
            case 'Revert Assigned Serial Number':
                const isProductUndefined = tableData ? tdData['product'] === undefined : Boolean(someProperty['product'].value) == 0
                title = isProductUndefined ? 'Choose valid Product' : "Provide the selected product's quantity";
                text = isProductUndefined ? 'Please select the product to add the table' : 'Please enter the quantity to add the Table';
                break;
            case 'Buffer Serial Number':
            case 'Delivery' :
            case 'Reclamation Delivery':
                const isMaterialUndefined = Object.hasOwn(someProperty, 'material') ? Boolean(someProperty['material'].value) == 0 : Boolean(someProperty['product'].value) == 0;
                title = isMaterialUndefined ? 'Choose valid Material' : "Provide the selected material's quantity";
                text = isMaterialUndefined ? 'Please select the material to add the table' : 'Please enter the quantity to add the Table';
                break;
            default:
                break;
        }
        if (title && text) {
            swal({
                title,
                text,
                icon: "warning",
                button: `${t("alerts.ok")}`
            });
        }
      }catch(error){
        setHasError({
            error: true,
            message: error
          })
      }
    }

    function getRowsData(){
     try{
        var items = unique;
        let keys = getKeysYML();
        let lastIndex = items.length - 1;
    
        return items.map((row, index)=>{

            if(row?.ApplicableFrom) {
                return <tr key={index}><RenderRow key={index} data={row} keys={keys}/>
            </tr> 
            }
            else {
                return <tr key={index}>
                    <RenderRow key={index} data={row} keys={keys}/>
                    {props.commonTitle !== "Vendor Serial Number" || props.commonTitle !== "Reclamation PO" ?  
                    <td>
                        <button className="btnCls" 
                            style={{
                                    backgroundColor: buttonBackgroundColor,
                                    color: buttonTextColor,
                                    textAlign: 'center',
                                    minWidth:'70px'
                                }}
                        // style={{borderRadius:'15px',float:'right',marginRight:'5%'}}
                         onClick={ () => deleteRow(index)}>{`${t('delete')}`}</button>
                    </td>
                :
               " "
            }
                </tr>
            }
        })
    }catch(error){
        setHasError({
            error: true,
            message: error
          })
    }
    }

    const RenderRow = (props) => {
        return props.keys.map((key, index)=>{
        return i18n.language === "chi" ? <td key={props.data[key]} >{props.data[key["datafield"]]}</td> : <td key={props.data[key]} >{props.data[key]}</td> 
        })
    }
  
    const deleteRow = (i) => {
      try{
        setReadOnly(false)
        swal({title:`${t("alerts.sure")}`, text:`${t("alerts.deleted_not_recovered")}`,
        icon:"warning",
        buttons: [`${t('alerts.cancel')}`,
        `${t('alerts.ok')}`],
         dangerMode: true,
        })        
        .then((willDelete) => {
          if (willDelete) {
            const newArr = [...unique];
            const toRemove =  newArr.splice(i, 1);
            const index = newArr.indexOf(toRemove);
                if (index > -1) { 
                    newArr.splice(index, 1);
                }
            setTableList(newArr);
            swal(`${t("alerts.data_deleted")}`, {
              icon: "success",
              timer: 2000,
              button: false
            });
          } else {
            swal(`${t("alerts.data_safe")}`, {
              timer: 2000,
              button: false
            });
          }
        });
     }catch(error){
        setHasError({
            error: true,
            message: error
          })
     }
    }

    const getSelectableTransactions = (selectableTransactions) => {
      try{
        if (selectableTransactions?.length > 0) {
            const modifiedDnDoptions = selectableTransactions.map(item => {
                item.isSync = 0;
                item.isMandatory = 0;
                return item;
            });
            return modifiedDnDoptions;
        }
        return selectableTransactions
       }catch(error){
        setHasError({
            error: true,
            message: error
          })
       }
    }

    useEffect(() => {
      try{
        if(props.commonTitle === 'Price') 
        uniq = tableList;
        
        if (props.commonTitle === 'AttributeSets' || props.commonTitle === "Download IOT's(Buffer)" || props.commonTitle === 'Product Trasaction') {
            let jsonObject = tableList.map(JSON.stringify);
            let uniqueSet = new Set(jsonObject); 
            let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
            uniq = uniqueArray;
            } else if (props.commonTitle === "Revert Assigned Serial Number") {
                uniq = tableList.filter(function({product},index) {
                    if((this[product] != tableList[tableList.length-1].product)){
                        return !this[product] && (this[product] = product)
                    }
                }, {})
            setTdData([])
            }
            else if (props.commonTitle === 'Pick List') {
            uniq = tableList.filter(function({delivery_no},index) {
                if((this[delivery_no] != tableList[tableList.length-1].delivery_no))
                return !this[delivery_no] && (this[delivery_no] = delivery_no)
            }, {})
            }
            else if (props.title === "Buffer Serial Number") {
                uniq = tableList.filter(function({product},index) {
                    if((this[product] != tableList[tableList.length-1].product)){
                        return !this[product] && (this[product] = product)
                    }
                }, {})
            setTdData([])
            }
            else if(props.commonTitle === "AttributeSet" && cookies.get("customer_id") == 12){
                const attributeArray = tableList.flat();
                uniq = attributeArray;
            }
            else if (props.commonTitle === "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") {
                uniq = tableList.filter(function({product},index) {
                    if((this[product] != tableList[tableList.length-1].product)){
                        return !this[product] && (this[product] = product)
                    }
                }, {})
            setTdData([])
            }
            else if (props.commonTitle === "Vendor Serial Number" || props.commonTitle === "Reclamation PO" || props.commonTitle == "Purchase Order") {
                uniq = tableList
            }
            else if(props.commonTitle === "Download IOT's(Buffer)"){
                uniq = tableList.filter(function({transaction},index) {
                    if(this[transaction] && (this[transaction] == tableList[tableList.length-1].transaction))
                    swal("Duplicate Values", "Material cannot be repeated", "error");
                    return !this[transaction] && (this[transaction] = transaction)
                }, {})
                setTdData([])
            }
            else if(props.commonTitle === "Product Transaction"){
                uniq = tableList.filter(function({transaction},index) {
                    if(this[transaction] && (this[transaction] == tableList[tableList.length-1].transaction))
                    swal("Duplicate Values", "Transaction cannot be repeated", "error");
                    return !this[transaction] && (this[transaction] = transaction)
                }, {})
                filteredData = productTransactionTableList.filter(function({transaction},index) {
                    if(this[transaction] && (this[transaction] == productTransactionTableList[productTransactionTableList.length-1].transaction))
                    swal("Duplicate Values", "Transaction cannot be repeated", "error");
                    return !this[transaction] && (this[transaction] = transaction)
                }, {})
                setTdData([])
            }
            else if(cookies.get("customer_id") === "17" && props.title === "Delivery"){
                uniq = tableList;
            }else if(props.commonTitle == "BOM Mapping"){
                uniq = tableList;
            }
            else if(props.commonTitle == 'Reclamation Delivery' || props.commonTitle !== "Download IOT's(Buffer)") {
            uniq = tableList.filter(function({material},index) {
                if(this[material] && (this[material] == tableList[tableList.length-1].material))
                swal({title:`${t("alerts.duplicate_values")}`, text:`${t("alerts.material_repeated")}`, icon:"error", button:`${t("alerts.ok")}`})
                return !this[material] && (this[material] = material)
            }, {})
            setTdData([])
            }
            // else {
            //     uniq = tableList.filter(function({material},index) {
            //         if(this[material] && (this[material] == tableList[tableList.length-1].material))
            //         swal("Duplicate Values", "Material cannot be repeated", "error");
            //         return !this[material] && (this[material] = material)
            //     }, {})
            //     setTdData([])
            // }
            if(uniq){
                setUnique(uniq);
                setUniqueData(filteredData);
                setParentTableLength(Object.keys(uniq).length)
                let lastIndex = (Object.keys(uniq).length)-1
                if(lastIndex>=0) {
                    if(uniq[lastIndex]?.ApplicableFrom &&
                    uniq[lastIndex]?.ApplicableFrom >= moment(new Date()).format("MM-DD-YYYY"))
                    setDisabled(true);
                }
            }
        }catch(error){
            setHasError({
                error: true,
                message: error
              })
        }   
    }, [tableList]);

    useEffect(() => {
        if(checked == false){
            setMultiUploadFiles([])
        }
    },[checked])

    useEffect(() => {
        let getdrpdwnresponseJson;
        (async () => {
            try{
            setDisabled(false);
            if(props.drpdwnApi === 'not found' || props.drpdwnApi === undefined) {
                for (const [key] of  Object.entries(props.formValue)) {
                    if(key === 'reference_id'){
                        props.formValue[key].value = props.loyaltyRedeem?.referenceNo
                    }
                    else if(props.titlePreFix === `${t("import")}` && props.title === 'Entities' && key === 'ware_id'){
                        props.formValue[key].elementConfig.options = [
                            ...initialValue,
                            ...(props?.wareIds || [])
                          ];
                    }
                }
            setloadSForm(false);
            setReleaseNotes('')
            }
            else {
                setModalformValues(props.formValue);
                setloadSForm(true);
                const getdrpdwnresponse = await FetchAPI(props.drpdwnApi);
                handleNetworkErrors(getdrpdwnresponse,setHasError);
                getdrpdwnresponseJson = await getdrpdwnresponse.json();
                if (props.commonTitle === "Transaction Groups") {
                    const selectableTransactions = getSelectableTransactions(getdrpdwnresponseJson?.data)
                    setSelectElements(selectableTransactions);
                    setSelectedElements([])
                }
                setloadSForm(false);
                setForm(getdrpdwnresponseJson)
                const updateForm = {
                    ...props.formValue
                }
                const dropVal = {
                    ...getdrpdwnresponseJson.data
                }
                let obj;
                obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
                    if(updateForm.hasOwnProperty(el)){
                        if(!isEmpty(dropVal[el])){
                            if(updateForm[el].elementType == 'select' || updateForm[el].elementType == 'selectshowlabel' || updateForm[el].elementType == 'selectshowsearch'){
                                if(props.commonTitle === 'Reclamation Delivery' && el === 'to_location'){

                                    updateForm[el].elementConfig.options = dropVal['to_locations']
                                }
                                else{
                                    updateForm[el].elementConfig.options = dropVal[el];
                                }
                                if(props.title === 'Assign IOT' && el === 'location_types'){
                                    if(!updateForm[el].update.required){
                                    updateForm['locations'].elementConfig.options = [];
                                }
                             }
                                if (props.commonTitle === 'IOT Bulk Download' && el === 'vendorId' && !(cookies.get('userRole_name') === 'Super Admin')){
                                    updateForm[el].validate.required = false;
                                }
                                if(updateForm[el].elementType == 'select' || updateForm[el].elementType == 'selectshowlabel'){
                                updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                                if(props.commonTitle === 'Assign Serial Number') {
                                    updateForm['po_mode'].elementConfig.readonly = false
                                }
                                }
                                if(updateForm[el].elementConfig.hasOwnProperty('type') &&
                                updateForm[el].elementConfig.type == 'static2') {
                                    updateForm[el].value = props.val1
                                }
                                /*Rendering The Dynamic Value In Parent field with in "Features List" feature  */
                                if(updateForm[el].elementConfig.hasOwnProperty('type') &&
                                updateForm[el].elementConfig.type == 'static1' && updateForm[el]?.update?.endPoint) {
                                    updateForm[el].value = props.val1
                                // updateForm[el].elementConfig.options.displayValue === 'Select Vendor Name' ? updateForm[el].value = null : updateForm[el].value = props.val1    
                            let getURL = updateForm[el].update.endPoint+'?'+el+'='+props.val1;
                                const commanParamVal = new URLSearchParams(commonParams);
                                let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                                setModalformValues(updateForm);
                                updateDropDwon(newgetURL, updateForm);
                              }
                /*Rendering The Dynamic Value In Parent field with in "Features List" feature  */
                             
                            }
                            if(updateForm[el].elementType == 'multiselect')
                              updateForm[el].elementConfig.options = dropVal[el];
                        }else
                        {
                            if(updateForm[el].elementType == 'select' ||  (props.commonTitle === 'Vendor Serial Number' && updateForm['po_number'].elementType == 'selectshowlabel')){
                                updateForm[el].elementConfig.options = initialValue;
                            }
                        }
                    }
                })
                setModalformValues(updateForm);
                setloadSForm(false);
            }
            if((props.titlePreFix == `${t('edit')}` && props.title !== 'Loyalty Redeem') || props.titlePreFix == `${t("view")}` || props.titlePreFix == 'Generate'){
                setloadSForm(true);
                if(props.title == "Location Type"){
                    setloadSForm(false)
                    setLoading(true)
                }
                const getresponse = await FetchAPI(props.getURL);
                handleNetworkErrors(getresponse,setHasError);
                const getresponseJson = await getresponse.json();
                if (props.commonTitle === "Transaction Groups") {
                    const selectableTransactions = getSelectableTransactions(getresponseJson?.data?.selectableTransactions)
                    setSelectElements(selectableTransactions)
                    setSelectedElements(getresponseJson?.data?.selectedTransactions)
                }else if(props.commonTitle === "Field"){
                    if(props.titlePreFix === "Edit"){
                        setCustomFormData(getresponseJson?.data)
                    }
                }
                setFormInputs(getresponseJson.data)
                if(getresponseJson.data.hasOwnProperty('attributes')) {
                    const responseData1 = getresponseJson.data.attributes;
                    const dropVal1 = {
                        ...responseData1
                    }
                    const updateForm = {
                        ...props.formValue
                    }
                    Object.keys(getresponseJson.data.attributes).forEach((el) => {
                        if(updateForm.hasOwnProperty(el))
                                updateForm[el].value = dropVal1[el];
                    })
                    setModalformValues(updateForm);  
                }
                if(getresponseJson.data.tableData) {
                    setTableList(getresponseJson.data.tableData);
                }else if(getresponseJson.data.attributes){
                    setTableList(getresponseJson.data.attributes);
                }
                const responseData = getresponseJson.data;
                const dropVal = {
                    ...responseData
                }
                let updateForm = {
                    ...props.formValue
                }
                if (props.title === 'Build/Software' || props.title === "Build") {
                    let response = Object.values(dropVal)
                    let docdetails;
                    let builddetails;
                    if ("builddetails" in dropVal) {
                        builddetails = { ...response[0] }
                        docdetails = [ ...response[1]]
                        setDocLinks(docdetails)
                        let decodeurl = decodeURIComponent(builddetails['url'])
                        const Url = Object.keys(builddetails).reduce((file, key) => {
                            if(key === 'url'){
                            file.push({ name: decodeurl.substring(decodeurl.lastIndexOf('/')+1)});}
                            return file;
                        }, []);
                        setBuildUrl(Url)
                        let arr1 = []
                        const nameValue = obj => Object.keys(obj).reduce((results, key) => {
                            results.push({ name: key, value: obj[key] });
                            return results;
                        }, []);
                        let zip = nameValue(builddetails)
                        zip.map(function (fValue, id) {
                            arr1[fValue.name] = fValue.value
                        })
                        const buildFormFields = ["platform","version","clear_db","clear_settings","clientId","locations"]
                        Object.keys(arr1).map((key) => {
                            if(buildFormFields.includes(key)){
                                updateForm[key].value = arr1[key]
                            }
                            if (key === 'release_notes') {
                                setReleaseNotes(arr1[key])
                            }
                            setBuildInputVal(updateForm)
                        })
                    }if("docdetails" in dropVal) {
                        const Url = Object.values(docdetails).reduce((file, fileName, key) => {
                            file.push({name : decodeURIComponent(fileName['file']).substring(decodeURIComponent(fileName['file']).lastIndexOf('/') + 1)});
                            return file;
                        }, []);
                        setDocUrl(Url)
                        Object.keys(staticModalformValues).forEach((key) => {
                            if(key === 'release_doc' && docdetails.length > 0){
                                setChecked(true)
                            }
                        })
                    }
                } 
                if(props.commonTitle === "Global"){
                    if(Object.hasOwn(updateForm,'type')){
                        updateForm['type'].value = props.extraId
                        setSelectedType(props.extraId)
                    }
                }                  
                if(dropVal['latitude'] !== null &&  dropVal['longitude'] !== null) {
                    setCenter({lat: dropVal['latitude'], lng: dropVal['longitude']})
                    setMapPosition({lat: dropVal['latitude'], lng: dropVal['longitude']})
                    setMarkerPosition({lat: dropVal['latitude'], lng: dropVal['longitude']})
                    setState(dropVal['state'])
                    setCountry(dropVal['country'])
                    setCity(dropVal['city'])
                    setArea(dropVal['area'])
                    setAddress(dropVal['location_address'])
                }else{
                    setLat(dropVal['latitude'])
                    setLan(dropVal['longitude'])
                    setState(dropVal['state'])
                    setCountry(dropVal['country'])
                    setCity(dropVal['city'])
                    setArea(dropVal['area'])
                    setAddress(dropVal['location_address'])
                }
                // }else{
                //     setLat(dropVal['latitude'])
                //     setLan(dropVal['longitude'])
                //     setState(dropVal['state'])
                //     setCountry(dropVal['country'])
                //     setCity(dropVal['city'])
                //     setArea(dropVal['area'])
                //     setAddress(dropVal['location_address'])
                // }
                
            /* Populate the locations as a DropDown with in the Parent Locations selective I/P Field in "Company Locations" Feature */
                if(updateForm['parent_location'] && dropVal['parentlocations']) {
                    updateForm['parent_location'].elementConfig.options = dropVal['parentlocations'];
                    updateForm['parent_location'].elementConfig.options.splice(0, 0, ...initialValue)
                }
                // if(updateForm['material'] && dropVal['material_details']) {
                //     updateForm['material'].value = dropVal['material_details'][0].label
                // }
             /*Populate the locations as a DropDown with in the Parent Locations selective I/P Field in "Company Locations" Feature */                                                                            
                let obj;
                if(updateForm['location_id'] && dropVal['locations']) {
                    setDynamicParams({
                        'location_type_id':dropVal['location_type_id'],
                        'location_id':dropVal['location_id']
                    })
                    updateForm['location_id'].elementConfig.options = dropVal['locations'];
                    updateForm['location_id'].elementConfig.options.splice(0, 0, ...initialValue)
                    }
                    if (props.commonTitle === "Location" && Object.hasOwn(getdrpdwnresponseJson.data, 'location_type')) {
                        const formValues = getdrpdwnresponseJson.data['location_type'].filter(el => el.displayValue === 'Vendor' || el.displayValue === 'Customer');
                        if (formValues.find(el => el.value === getresponseJson.data['location_type'])) {
                            const updatedFormValues = Object.keys(props.formValue).filter(key => key !== 'business_unit').reduce((newObj, key) => {
                                newObj[key] = props.formValue[key];
                                return newObj;
                            }, {});
                            updateForm = { ...updatedFormValues };
                            setButtonOverlap(!buttonOverlap)
                        }
                    }
                    obj = Object.keys(getresponseJson.data).forEach((el) => {
                            if(updateForm.hasOwnProperty(el)){
                                if(props.commonTitle === "Global"){
                                    if(el === "username" && updateForm[el].elementType === 'multiselect'){ 
                                    const value = updateForm[el].elementConfig.options?.filter((ele) => ele.value == dropVal[el][0].value)
                                    updateForm[el].value = value
                                    return null;
                                }
                                }
                                if (props.title === 'Assign IOT For BU') {
                                    if (el === 'location_types') {
                                        const selectedLocationType = updateForm[el].elementConfig.options?.find(
                                            item => item.value === dropVal['location_type_id']
                                        ) ?? null;
                                        if (selectedLocationType) {
                                            const { locations: locationsBasedOnType, ...rest } = selectedLocationType;
                                            updateForm[el].value = [selectedLocationType];
                                            updateForm['locations'].elementConfig.options = locationsBasedOnType;
                                            const selectedChildLocation = locationsBasedOnType.find(
                                                item => item.value === dropVal['location_id']
                                            ) ?? null;
                                            if (selectedChildLocation) {
                                                updateForm['locations'].value = [selectedChildLocation];
                                            }
                                        }
                                    } else if (el === 'bu_id') {
                                        const selectedBU = updateForm[el].elementConfig.options?.find(
                                            item => item.value === dropVal['buId']
                                        ) ?? null;
                                        if (selectedBU) {
                                            updateForm[el].value = [selectedBU];
                                        }
                                    } else if (['threshold', 'chunk', 'to_be_assign', 'iot_type'].includes(el)) {
                                        updateForm[el].value = dropVal[el];
                                    }
                                }
                              else updateForm[el].value = dropVal[el];
                        let modifiedArray
                        if(updateForm['material'] && dropVal['material_details']) {
                            updateForm[el].elementConfig.options = dropVal['material_details'];
                            updateForm['material'].value = dropVal['material'];
                        }
                        if(dropVal['whitelist_ip_check']){
                            if(Object.hasOwn(updateForm,'whitelist_check')) {
                                updateForm['whitelist_check'].value = true
                            }
                            setDisabledOnCheck((prevState) => {
                                return ({
                                    ...prevState,
                                    whiteList : true
                                })
                            })
                        }
                        // if(updateForm['sequence']){
                        //     updateForm['sequence'].value = dropVal['sequence']?.sequence;
                        // }

                        if(updateForm['qc_params'] && dropVal['qc_params']){
                            let modifiedOptions = updateForm['qc_params'].elementConfig.options
                            modifiedArray  = dropVal['qc_params'].reduce((acc,currentValue,_,arr) => {
                                modifiedOptions.forEach((el,id) => {
                                        if(el.value === currentValue.value){
                                            acc.push({value:el.value,label:currentValue.label})
                                        }
                                    })
                                return acc
                            },[])
                            updateForm['qc_params'].value = modifiedArray
                        }
                        // if(updateForm[el].elementConfig.hasOwnProperty('type') &&
                        //       updateForm[el].elementConfig.type == 'static1') {
                        //         updateForm[el].value = props.val1
                        //         let getURL = updateForm[el].update.endPoint+'?'+el+'='+props.val1;
                        //         const commanParamVal = new URLSearchParams(commonParams);
                        //         let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                        //         setModalformValues(updateForm);
                        //         updateDropDwon(newgetURL, updateForm);
                        //       }
                    }
                })
                if(updateForm["location_type"]?.asyncUpdate?.required){
                    updateForm["parent_location"].elementConfig.asyncEndpoint = updateForm["location_type"]?.asyncUpdate?.endPoint
                    updateForm["parent_location"].elementConfig.location_type = updateForm["location_type"]?.value
                }
                setModalformValues(updateForm);          
                setloadSForm(false);
                setLoading(false);
     }
                if (props.isIOT && props.fetchIOT) {
                    const title = props.title.split(" ")[0];
                    props.getIotCounts(setloadSForm, title);
                };
            } catch (e) {
                setHasError({
                    error: true,
                    message: e
                })
            }
        })()
        return () => {
            if("qty" in props.formValue){
                props.formValue.qty.value = "";
            }
            setDropdownApiData([]);
            const defaultValue = [{displayValue: "Please Select",value: null}];
            if(cromptonDownloadIot){
                ModalformValues.final_products.elementConfig.options = defaultValue;
            }
            if(cromptonDelivery){
                ModalformValues.from_location.elementConfig.options = defaultValue;
                ModalformValues.to_location.elementConfig.options = defaultValue;
            }
            if("abortControllerRef" in props){
                if(props.abortControllerRef.current){
                    props.abortControllerRef.current.abort();
                  }
            }
        }
    }, []);

    const editHandler = (data) => {
        setEdit(data)
    }

    //Release notes handler (future use)
    // const formInputChangeHandler = (event) =>{
    //     Object.keys(staticModalformValues).forEach((key) => {
    //         if(key.includes(event.target.name)){
    //             if(event.target.type === 'checkbox'){
    //                 if(event.target.checked == 0){
    //                 staticModalformValues[key].value = true
    //              }else if (event.target.checked == 1){
    //              staticModalformValues[key].value = true
    //             }else{
    //                 staticModalformValues[key].value = event.target.checked
    //             }
    //             setChecked(event.target.checked)
    //         }
    //             else if(staticModalformValues.hasOwnProperty('release_notes')){
    //                 staticModalformValues[key].value = event.target.value
    //                 setReleaseNotes(event.target.value)
    //             }
    //         }
    //     })
    // }

    const fetchAsyncOptions = async(inputValue,endpoint,location_type) => {
        if(location_type){
            commonParams = {...commonParams, location_type}
        }
        if(inputValue){
            commonParams = {...commonParams, element: inputValue}
        }        
        const commanParamVal = new URLSearchParams(commonParams);
        const newEndPoint = (`${endpoint}?${commanParamVal.toString()}`);
        const response = await FetchAPI(newEndPoint)
        const responseJson = await response.json()
        return responseJson.data.data
    }    

    const inputModalChangedHandler = (event, inputIdentifier) => {
        try{
        const updateOrderForm = {
            ...ModalformValues
        }
        const updateElemetForm = {
            ...updateOrderForm[inputIdentifier]
        };
        if(updateOrderForm[inputIdentifier].elementType === 'radio') {
            updateElemetForm.value=event.target.value
        }
        if(updateOrderForm[inputIdentifier].elementType === 'switch') {
            updateElemetForm.value=!updateElemetForm.value
        }
        else if(updateOrderForm[inputIdentifier].elementType === 'checkbox') {
            if(event.target.checked == 0){
            updateElemetForm.value = false;
            setDisabledOnCheck((prevState) => {
                return ({
                   ...prevState,
                   ...(props.featureTitle === 'Transaction' && {transaction : false}),
                   ...(inputIdentifier === 'whitelist_check' && {whiteList : false})
                        })
                })
            setTableList([])
            }
            else if(event.target.checked == 1){
            updateElemetForm.value = true;
            setDisabledOnCheck((prevState) => {
                    return ({
                       ...prevState,
                       ...(props.featureTitle === 'Transaction' && {transaction : true}),
                       ...(inputIdentifier === 'whitelist_check' && {whiteList : true})
                            })
                })
            Object.keys(updateOrderForm).forEach((el) => {
                if(el === 'transaction' || el === 'sequence'){
                    updateOrderForm[el].value = ''
                }
            })
            if(updateElemetForm.update.required === true && updateElemetForm.update?.endPoint){
                let getURL = updateOrderForm[inputIdentifier].update.endPoint;
                const commanParamVal = new URLSearchParams(commonParams);
                let newgetURL = (`${getURL}?${commanParamVal.toString()}`);
                updateDropDwon(newgetURL, updateOrderForm);
            }
            }
            else{
            updateElemetForm.value = event.target.checked;
            }
        }
        else if((updateOrderForm[inputIdentifier].elementType === 'file')) {
            if(event.target.files[0])
                setSelectedFile(event.target.files[0])
        }
        else if (updateOrderForm[inputIdentifier].elementType == 'multiselect') {
            if(Array.isArray(event) && event.length !== 0){
                updateElemetForm.value = event;
                if(inputIdentifier === 'location_types' && props.title === 'Assign IOT For BU'){
                    setBuLocations(() => {
                        const allSelectedLocations = event.flatMap(item => item.locations);
                        const uniqueLocationsMap = new Map();
                        allSelectedLocations.forEach(location => {
                            uniqueLocationsMap.set(location.value, location);
                        });
                        const uniqueLocations = Array.from(uniqueLocationsMap.values());
                        updateOrderForm['locations'].elementConfig.options = uniqueLocations;
                        return uniqueLocations;
                    });
                    updateOrderForm['locations'].value = null;
                }
            }
            else{
                if(inputIdentifier === 'location_types' && props.title === 'Assign IOT For BU'){
                if(!event.length){
                updateOrderForm['locations'].value = null;
                updateOrderForm['locations'].elementConfig.options = [];
                }
            }
                updateElemetForm.value = null;
            }
        }
        else {
            if(updateOrderForm[inputIdentifier].elementType == 'select' || updateOrderForm[inputIdentifier].elementType == 'selectshowlabel' && event.target.value !== `${t('please_select')}`){
                if(props.commonTitle === "Download IOT" && Object.hasOwn(dropdownApiData, 'final_products') && inputIdentifier === "final_products"){
                    const [, ...newArray] = dropdownApiData.final_products;
                    updateOrderForm.qty.value  = newArray.find((el) => el.value === event.target.value)?.qty
                }
                updateElemetForm.value = event.target.value;
                if(updateOrderForm[inputIdentifier]?.asyncUpdate?.required){
                    for(let key in updateOrderForm){
                        if(updateOrderForm[key].elementConfig?.async){
                            updateOrderForm[key].elementConfig.asyncEndpoint = updateOrderForm[inputIdentifier]?.asyncUpdate?.endPoint
                            if(updateOrderForm[inputIdentifier].id === "location_type"){
                                updateOrderForm[key].elementConfig.location_type = event.target.value
                            }
                            updateOrderForm[key].value = null;
                        }
                    }
                }
                if(props.title === "Build" && inputIdentifier === "clientId"){
                    let updatedModalFormValues = {
                        ...ModalformValues
                    }
                    if(event.target.value === "all"){
                        updatedModalFormValues.locations.validate.required = false;
                        updatedModalFormValues.locations.elementConfig.disabled = true;
                        updatedModalFormValues.locations.elementConfig.disableSearch = true
                        updatedModalFormValues.locations.label = "Location";
                        setModalformValues(updatedModalFormValues)
                    }else{
                        updatedModalFormValues.locations.validate.required = true;
                        updatedModalFormValues.locations.elementConfig.disabled = false;
                        updatedModalFormValues.locations.elementConfig.disableSearch = false;
                        updatedModalFormValues.locations.label = "Location*";
                        setModalformValues(updatedModalFormValues)
                    }
                }
                if (cromptonAssignIot) {
                    const index = event.nativeEvent.target.selectedIndex;
                    const label = event.nativeEvent.target[index].text;
                    updateElemetForm["optionLabel"] = label;
                }
                if(props.title === "Loyalty Redeem"){
                    let updatedModalFormValues = {
                        ...ModalformValues
                    }
                    if(event.target.value === "1"){
                        updatedModalFormValues.remarks.label = "Remarks"
                        updatedModalFormValues.remarks.validate.required = false;
                    }else if(event.target.value === "2"){
                        updatedModalFormValues.remarks.label = "Remarks*"
                        updatedModalFormValues.remarks.validate.required = true;
                    }
                    setModalformValues(updatedModalFormValues)
                }
                if(props.commonTitle === 'Category' && cookies.get("customer_id") === "13"){
                    if(form) {
                        let obj = Object.keys(form.data).forEach((el) => {
                            let arrayConvert = [];
                         if(Object.keys(el, updateOrderForm)){
                                form.data['parent_id'].map(function(fValue, indexId){
                                    arrayConvert[fValue.value] = fValue.loyaltyValue;
                        })
                         }
                         updateOrderForm['loyalty_points'].value = arrayConvert[event.target.value];
                        })
                    }
            }
            }
            
            else if(updateOrderForm[inputIdentifier].elementType == 'input') {
                const input = event.target.value
                if(updateOrderForm[inputIdentifier].elementConfig.type === 'numeric'){
                const regex = /^\d*\.?\d*$/;
                if (regex.test(input)) {
                    updateElemetForm.value = input;
                }
                }else{
                    updateElemetForm.value = input;
                }
            }

            else if(updateOrderForm[inputIdentifier].elementType === "asyncSelect"){
                if(event){
                    updateElemetForm.value = event
                }
            }
         else if(updateOrderForm[inputIdentifier].elementType == 'selectshowsearch'){ 
            if(event){
            updateElemetForm.value = event;
                if(inputIdentifier === 'location_types' && props.title === 'Assign IOT'){
                    setBuLocations(() => {
                        const allSelectedLocations = event.locations;
                        const uniqueLocationsMap = new Map();
                        allSelectedLocations.forEach(location => {
                            uniqueLocationsMap.set(location.value, location);
                        });
                        const uniqueLocations = Array.from(uniqueLocationsMap.values());
                        updateOrderForm['locations'].elementConfig.options = uniqueLocations;
                        return uniqueLocations;
                    });
                    updateOrderForm['locations'].value = null;
                }
            if(props.title === "Download IOT" && cookies.get("customer_id") === "17" && inputIdentifier === 'po_number'){
                updateOrderForm.qty.value  = null
            }
             if (dynamicParam.transactioncategory === event.label){
                 updateOrderForm['qc_params'].value = dynamicParam.qc_params
            }  

            if(props.commonTitle === "BOM Mapping" && inputIdentifier === "product_id"){
                updateOrderForm["bom_id"].value = "";
                updateOrderForm["qty"].value = "";
            }

            if((inputIdentifier === 'transactioncategory') || (props.commonTitle == 'Revert Assigned Serial Number' && inputIdentifier === 'po_number')){
                let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+updateElemetForm.value.value;
                const commanParamVal = new URLSearchParams(commonParams);
                let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                updateDropDwon(newgetURL, updateOrderForm);   
             }
             if((props.commonTitle == 'Product Transaction' && inputIdentifier === 'location')){
                let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+updateElemetForm.value.value;
                const commanParamVal = new URLSearchParams(commonParams);
                let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                updateDropDwon(newgetURL, updateOrderForm);   
             }
             if(props.title === "Build" && (inputIdentifier === "clientId")){
                let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+updateElemetForm.value.value;
                const commanParamVal = new URLSearchParams(commonParams);
                let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                updateDropDwon(newgetURL, updateOrderForm);   
             }
             if(inputIdentifier === 'label_category'){
                    if( event !== '' && updateOrderForm[inputIdentifier].update.required === true){
                        let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event['value'];
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
            }
        }
        else if(cookies.get("customer_id") === "17" && inputIdentifier === "po_number") {
            let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event.value;
            const commanParamVal = new URLSearchParams(commonParams);
            let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
            updateDropDwon(newgetURL, updateOrderForm);
        }
        if(props.commonTitle ==='Buffer Serial Number'){
            if(inputIdentifier === 'vendorId'||inputIdentifier==='po_number'){
                let getURL =updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event.value;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
        }
    }
                if ("qty" in event) {
                    updateOrderForm.qty.value = event.qty;
                }
                }
                else{
                    updateElemetForm.value = '';
                }
            }
            else if(updateOrderForm[inputIdentifier].elementType == 'textarea'){
                updateElemetForm.value = event.target.value;
                setUnBindValue(event.target.value)
            }
            else{
                updateElemetForm.value = null; 
            }
        }
        updateOrderForm[inputIdentifier] = updateElemetForm;
        if(props.commonTitle === "Global" && Object.hasOwn(updateOrderForm,'type')){
            const typeValue = updateOrderForm.type?.value;
            setSelectedType(
                typeValue && typeValue !== `${t('please_select')}` ? typeValue : null
              );
        }
            let updatedQCpayload = {};
            if (props.title === 'QC Attributes') {
                for (const key in updateOrderForm) {
                    if (updateOrderForm.hasOwnProperty(key) && updateOrderForm[key].hasOwnProperty('value')) {
                        let valueToAssign = +updateOrderForm[key].value?.value;;
                        if (key === 'qc_params') {
                            valueToAssign = updateOrderForm[key].value?.label;
                        }
                        if (Array.isArray(updateOrderForm[key].value)) {
                            updateOrderForm[key].value.forEach((fvalue, index) => {
                                valueToAssign = fvalue.value;
                                if (key === 'qc_params') {
                                    valueToAssign = fvalue.label;
                                    if (updateOrderForm[key].elementType === 'multiselect') {
                                        let modifiedArray = updateOrderForm['qc_params'].value.reduce((acc, currentValue, _, arr) => {
                                            acc.push(currentValue.label)
                                            return acc
                                        },[])
                                 valueToAssign = modifiedArray
                                }
                            }
                        })
                    }
                    updatedQCpayload[key] = valueToAssign
                    setDynamicParams({...updatedQCpayload})
                }
                }
            }
        setModalformValues(updateOrderForm);
        setCloneFormValues(JSON.parse(JSON.stringify(updateOrderForm)))
        setReason(updateElemetForm.value)
        // opening table data code
        if(((cookies.get("customer_id") === '13' || cookies.get("customer_id") === '16' || cookies.get("customer_id") === '19') && props.commonTitle === 'Delivery' && props?.permission === false)&&(inputIdentifier == 'material' || inputIdentifier == 'qty'))
        {
            let val;
            let obj;
            val = updateElemetForm.value?.label || updateElemetForm.value
            if(inputIdentifier == 'product' || inputIdentifier == 'material'){
                obj = {
                    product_id: updateElemetForm.value?.value
                }
            }
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val,...obj}));
        }
        if(props.commonTitle === 'Reclamation Delivery'){
        if (inputIdentifier == 'material' || inputIdentifier == 'qty')
        {
            let val;
            val = updateElemetForm.value?.label || updateElemetForm.value
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val}));
        }
    }

        if((cookies.get("customer_id") === '14' && props.commonTitle === 'Delivery') && (inputIdentifier == 'material' || inputIdentifier == 'qty')){
            let val;
            val = updateElemetForm.value?.label || updateElemetForm.value
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val}));
        }
        if((cookies.get("customer_id") === '15' && props.commonTitle === 'Delivery') && (inputIdentifier == 'material' || inputIdentifier == 'qty')){
            let val;
            val = updateElemetForm.value?.label || updateElemetForm.value
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val}));
        }
        if((props.commonTitle === "Download IOT's(Buffer)")&&(inputIdentifier == 'material' || inputIdentifier == 'qty' || inputIdentifier == 'po_number'))
        {
                let val1 = updateElemetForm.value?.label || updateElemetForm.value
                let val2 = updateOrderForm['po_number'].value
            setTdData((tdData) => ({...tdData, ['po_number']:val2, [inputIdentifier]:val1}));
        }
        if(props.commonTitle === 'Purchase Order' && (inputIdentifier == 'product' || inputIdentifier == 'qty')){
            let val;
            val = updateElemetForm.value?.label || updateElemetForm.value
            let obj = {}
            if(inputIdentifier == 'product' || inputIdentifier == 'material'){
                obj = {
                    product_id: updateElemetForm.value?.value
                }
            }
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val,...obj}));
        }
        //mango bom
        if(props.commonTitle === 'BOM Mapping' && (inputIdentifier == 'product_id' || inputIdentifier == 'qty' || inputIdentifier == 'bom_id')){
            let val;
            let obj = {}
            if(inputIdentifier == 'product_id'){
                obj = {
                    prod_id: updateElemetForm.value?.value
                }
            }
            else if(inputIdentifier == 'bom_id'){
                obj = {
                    bom_id: updateElemetForm.value?.label,
                    bomId: updateElemetForm.value?.value
                }
            }
            val = updateElemetForm.value?.label || updateElemetForm.value
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val,...obj}));
        }
        if(cromptonAssignIot){
            let val;
            val = updateElemetForm?.optionLabel || updateElemetForm.value
            let obj = {}
            if(inputIdentifier == 'businessUnit'){
                obj = {
                    businessUnitId: updateElemetForm.value
                }
            }
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val,...obj}));
        }
        if((props.commonTitle === "Vendor Serial Number" || props.commonTitle == "Reclamation PO"))
        {
            setTableList([]);
            setDisabled(false)
        }
        if((props.commonTitle === "Assign Serial Number")&&(inputIdentifier == 'vendorId'))
        {
            setTableList([]);
        }
        if((props.commonTitle === "Revert Assigned Serial Number")&&(inputIdentifier == 'po_number'))
        {
            setTableList([]);
        }
        if((props.commonTitle==='AttributeSets')&&(inputIdentifier == 'location' || inputIdentifier == 'product_group' || inputIdentifier == "transactions"))
        {
            let val;
            const customerId = cookies.get("customer_id");
            if(inputIdentifier == 'location' && Boolean(updateOrderForm['location'].value)) {
                let s=customerId == "12" ? updateElemetForm.value.label.split("(") :updateElemetForm.value.split("(");
                val = s[0]; 
            }
            else
            customerId == "12" ?  val = updateElemetForm.value.label : val = updateElemetForm.value
            setTdData((tdData) => {
                if (tdData.transactions && val !== undefined) {
                    return { ...tdData, [inputIdentifier]: val }
                } else if (inputIdentifier === "transactions" && val !== "" && val !== undefined) {
                    return { 
                        ...tdData, 
                        ...((customerId === "17" || customerId === "19") ? {[inputIdentifier]: val.label } : {[inputIdentifier]: val })}
                }
                return { ...tdData, [inputIdentifier]: val, transactions: "" }
            });
        }

        if(cookies.get("customer_id") == 12 && props.commonTitle === "AttributeSet" && inputIdentifier == "attributes"){
            setTdData(updateElemetForm.value)
        }

        if((props.commonTitle === 'Price')&&(inputIdentifier == 'Price' || inputIdentifier == 'ApplicableFrom' || inputIdentifier == 'Remarks'))
        {
            let val = updateElemetForm.value;
            setTdData((tdData) => ({...tdData, [inputIdentifier]: val}));
        }
        if((props.commonTitle === 'Product Transaction')&&(inputIdentifier == 'transaction' || inputIdentifier == 'sequence'))
        {
            let val = updateElemetForm.value?.label || updateElemetForm.value;
            let val2 = updateElemetForm.value?.value || updateElemetForm.value;
            setTdData((tdData) => ({...tdData,[inputIdentifier]: val}));
            setModifiedArray((modifiedArray) => ({...modifiedArray,[inputIdentifier]: val2}))
        }
        // closing table data code
        if(updateOrderForm[inputIdentifier].elementType == 'select'){
            if(updateOrderForm[inputIdentifier].update.required === true){
                let keyName = event.target.id;
                commonval = {
                    keyName:event.target.value
                }
                if(props.title ==='Buffer Serial Number'){
                    return
                }
                if((props.commonTitle === "Revert Assigned Serial Number")&&(inputIdentifier == 'product')){

                }
                else if(props.commonTitle === 'Reclamation Delivery'){
                        if((inputIdentifier === 'from_location')){
                            let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?location_id='+ cookies.get(globaldata.userLocationId);
                            const commanParamVal = new URLSearchParams(commonParams);
                            let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                            updateDropDwon(newgetURL, updateOrderForm);   
                    }
                }else if(event.target.value !== '') {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event.target.value;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                }
                else {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'=0';
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);   
                }
            }
        }
        setBuildInputVal(updateOrderForm)
    } catch (e) {
        setHasError({
          error: true,
          message: e
        })
      }
}

    const fileUpload = (files) => {
               setSelectedFile(files)
    }

    async function handleFormSubmit() {
        try {
            let len;
            let buildFormValues = {}
            if (validator.allValid()) {
                setDisabledButton(true);
                const buildKeys = ["platform","clientId","version","clear_settings","clear_db"];
                Object.keys(staticModalformValues).forEach((key) => {
                    if (key === 'release_notes') {
                        buildFormValues[key] = releaseNotes
                    } else if (key === 'release_doc') {
                        buildFormValues[key] = true
                    }
                    else if (buildKeys.includes(key)) {
                        buildFormValues[key] = buildInputVal[key]?.value
                    }else if(key === "locations"){
                        if(buildInputVal[key]?.value?.length === 1){
                            buildFormValues[key] = buildInputVal[key]?.value[0].value;
                            
                        }else if(buildInputVal[key]?.value?.length > 1){
                            const selctedLocations = buildInputVal[key]?.value?.map(location => (location.value))
                            buildFormValues[key] = selctedLocations;
                        }else{
                            buildFormValues[key] = "all";
                        }
                    }
                })
                const createFormData = (data) => {
                    return Object.keys(data).reduce((formData, key) => {
                        formData.append(key, data[key]);
                        return formData;
                    }, new FormData());
                };
                const formData = createFormData({ ...buildFormValues });
                if (props.titlePreFix === 'Edit') {
                    formData.append('id',props.editId)
                     formData.append('edit',editProp)
                     formData.append("docEdit",docEdit)
                     formData.append("buildEdit", buildEdit)
                    if (editFileUpload === true && edit == "MultiFileUpload") {
                        for (let i = 0; len = buildUrl.length, i < len; i++) {
                            formData.append('File', buildUrl[i])
                        }
                    }
                    if (edit === "singleFileUpload") {
                         for (let i = 0; len = buildUrl.length, i < len; i++) {
                            formData.append('File', buildUrl[i])
                        }
                        // for (let i = 0; len = doclinks.length, i < len; i++) {
                        //      formData.append('File', doclinks[i].file)
                        // }
                        // }
                        }
                    else if (edit === "MultiFileUpload") {
                        for (let i = 0; len = docUrl.length, i < len; i++) {
                            if (docUrl[i]?.lastModified) {
                                formData.append('File', docUrl[i])
                            } 
                              }
                            }
                            
                        }
                        else {
                            for (let i = 0; len = uploadFiles.length, i < len; i++) {
                                formData.append('File', uploadFiles[i])
                            }
                            for (let i = 0; len = multiUploadFiles.length, i < len; i++) {
                                formData.append('File', multiUploadFiles[i])
                            }
                        }
                        setLoading(true)
                        let getresponse = await PostAPI(props.addURL, formData);
                        handleNetworkErrors(getresponse,setHasError);
                        if(getresponse.status == 200){
                            setLoading(false)
                            if (getresponse?.data.data.status === 409) {
                                setloadSForm(false);
                                setDisabledButton(false);
                                return swal({
                                    icon: "error",
                                    title: "Error",
                                    text: getresponse?.data.data.message
                                })
                            } else {
                                swal({
                                    icon: "success",
                                    title: "Success",
                                    text: getresponse?.data.data.message
                                })
                                setDisabledButton(true);
                                props.recallMehod();
                                props.hide();
                            }
                        }else{
                            setLoading(false)
                            swal("Something went wrong!", {
                                icon: "warning",
                            });
                        }
                    } else {
                        showValidationMessage(true);
                    }
          }catch (error) {
            setHasError({
                error: true,
                message: error
              })
           }
        }
        
    async function updateEndPoint(url,FormVal, someProperty){
      try {
            let data = {}
            setloadSForm(true)
            if (props.commonTitle == "Assign Serial Number" || props.commonTitle == 'Reclamation Assign PO') {
                Object.keys(someProperty).forEach(el => {
                    if((el === 'Primary - Gift Box Quantity') || (el === 'product')) {
                        someProperty[el].value = ''
                    }
                    })
            data ={...commonParams, ...FormVal, vendorId:someProperty["vendorId"].value}
            } else if (props.commonTitle == "Vendor Serial Number" || props.commonTitle == 'Reclamation PO') {
                // someProperty['po_number'].value = ''
                data = {...commonParams,...FormVal}
            }else if (props.title == "Buffer Serial Number") {
                Object.keys(someProperty).forEach(el => {
                    if((el === 'Quantity') || (el === 'product')) {
                        someProperty[el].value = ''
                    }
                    })
                data = {...commonParams,...FormVal}
            }else if((props.commonTitle == 'Delivery' || props.commonTitle == 'Reclamation Delivery') && cookies.get("customer_id") !== "13" && cookies.get("customer_id") !== "19" && cookies.get("customer_id") !== "16" && cookies.get("customer_id") !== "17"){
                Object.keys(someProperty).forEach(el => {
                    if((el === 'material')|| (el === 'qty')){
                        someProperty[el].value = ''
                    }
                })
                data = {
                    ...commonParams,
                    ...FormVal,
                     from_location:someProperty["from_location"].value,
                     to_location:someProperty["to_location"].value.value.toString(),
                     po_number:someProperty["po_number"].value,
                    }
            }else if(props.commonTitle == 'Delivery'){
                Object.keys(someProperty).forEach(el => {
                    if((el === 'material')|| (el === 'qty')){
                        someProperty[el].value = ''
                    }
                    })
                data = {...commonParams,
                    ...FormVal,
                    from_location: someProperty['from_location'].value.value
                }
            } else if (props.commonTitle == 'Revert Assigned Serial Number') {
                Object.keys(someProperty).forEach(el => {
                    if ((el === 'product') || (el === 'Quantity')) {
                        someProperty[el].value = ''
                    }
                    })
            data ={...commonParams, ...FormVal}
            setDisabled(true)
            }
            // else if(props.commonTitle == "Download IOT's(Buffer)"){
            //     Object.keys(someProperty).map(el => {
            //         if((el === 'material')|| (el === 'qty')){
            //             someProperty[el].value = ''
            //         }
            //         })
            //     data = {...commonParams,
            //         ...FormVal,
            //          id:props.uniqueid,
            //          po_number:someProperty["po_number"].value,
            //         }
            // }
             else {
                data ={
                id:cookies.get('customer_id'),
                user_id:cookies.get('user_id'),
                from_location : FormVal['from_location'],
                deliveries : FormVal['deliveries']
                }
            }
            const response = await PostAPI(url,data);
            handleNetworkErrors(response,setHasError);
            setloadSForm(false)
            if(response.status == 400){
                if(props.commonTitle === "Revert Assigned Serial Number"){
                    setDisabled(false)
                }
                swal(response.message.response.data.error.message, {
                    icon: "error",
                    button:`${t("alerts.ok")}`
                });
                return
            }
             if (response.data.data.status === 409){
                  let msg = response.data.data.message;
                     alertMessage(msg)
                     setDisabled(false)
         
               
            }
            // }else if (response.data.data.status === 409){
            //     swal({
            //         title: `Inventory not available for ${response.data.data.titlematerial} (Qty - 20, Inv - 10)`,
            //         icon: "error",
            //        // timer: 2000,
            //        // button: false
            //     });
            // }
            //      else if (response.data.data.status === 202) {
            //     swal({
            //         title: `${response.data.data.message}`,
            //         text: "If you want to continue with the inventory qty then select ok!",
            //         icon: "info",
            //         buttons: true,
            //         dangerMode: true,
            //     }).then((willapply) => {
            //         let responseDataJson = response.data;
            //         if (willapply) {
            //         setTableList((tableList) => tableList.concat(responseDataJson.data));
            //         setTimeout(() => {}, 1000);
            //         }
            //     })
            // }
                 else if (response.data.data.status === 202) {
            swal({
                html: true,
                title: `Inventory not available for :\n ${response.data.data.material}`,
                text : `(Qty - ${parseInt(tdData.qty)}, Inv - ${response.data.data.qty})`,
                // text: "If you want to continue with the inventory qty then select ok!",
                icon: "info",
                dangerMode: true,
            })
            // .then((willapply) => {
            //     let responseDataJson = response.data;
            //     if (willapply) {
            //     setTableList((tableList) => tableList.concat(responseDataJson.data));
            //     setTimeout(() => {}, 1000);
            //     }
            // })
        }
             else if (response.data.data.status === 201) {
                tdData["material"].map((value) => {
                tdData["material"] = value.label;
                tdData["product_id"] = value.value;
                let tbData1 = { ...tdData };
                setTableList((tableList) => tableList.concat(tbData1));
          });
        }
            else if(response.status == 200){
                if(props.commonTitle === "Revert Assigned Serial Number"){
                    setDisabled(false)
                }
                    let responseDataJson = response.data;
                // response.data.data.body["material"].map((val) => {
                //     response.data.data.body["material"] = val.label
                // setTableList((tableList) => tableList.concat(tab))
                // })
                (props.commonTitle === "Revert Assigned Serial Number") ? setTableList((tableList) => tableList.concat(responseDataJson.data))
                :(props.title == "Buffer Serial Number") ?  setTableList((tableList) => tableList.concat(responseDataJson.data))
                :(props.commonTitle == "Assign Serial Number" || props.commonTitle == "Reclamation Assign PO") ?  setTableList((tableList) => tableList.concat(responseDataJson.data))
                // :(props.commonTitle == "Download IOT's(Buffer)") ? setTableList((tableList) => tableList.concat(responseDataJson.data))
                :(props.commonTitle == 'Delivery') ?  setTableList((tableList) => tableList.concat(responseDataJson.data))
                : (props.commonTitle == "Vendor Serial Number" || props.commonTitle == "Reclamation PO") ? setTableList((tableList) => tableList.concat(responseDataJson.data.po_details))
                : setTableList((tableList) => tableList.concat(responseDataJson.data.deliveries));
            }
            else {
                if(props.commonTitle === "Revert Assigned Serial Number"){
                    setDisabled(false)
                }
                setloadSForm(false);
                    swal(`${t("alerts.something_went_wrong")}`, {
                        icon: "error",
                        timer: 2000,
                        button: false
                        });
            }
        }
        catch (error) {
            setHasError({
                error: true,
                message: error
              })
        }
    }

    async function updateDropDwon(URL, FormVal){
      try {
          if(props.title == "Location"){
              setLoading(true)
          }
          setloadSForm(true)
          const getdrpdwnresponse = await FetchAPI(URL);
          handleNetworkErrors(getdrpdwnresponse,setHasError);
          if(getdrpdwnresponse.status == 200){
          const getdrpdwnresponseJson = await getdrpdwnresponse.json();
          setDropdownApiData(getdrpdwnresponseJson?.data);
          setLoading(false)
          setloadSForm(false)
          const updateForm = {
              ...FormVal
          }
          const dropVal = {
              ...getdrpdwnresponseJson.data
          }
          let obj;
          if(props.commonTitle === 'Product Transaction'){
              if(dropVal.tableData) {
                  const array = drpdwnResponse
                      .filter(el => el.includes('transaction'))
                      .flatMap(el => {
                          const transactionOptions = el[1];
                          return Object.values(dropVal.tableData)
                              .filter(value => transactionOptions.some(ele => ele.label === value.transaction))
                              .map(value => {
                                  const matchingOption = transactionOptions.find(ele => ele.label === value.transaction);
                                  return {
                                      transaction: matchingOption.value,
                                      sequence: value.sequence
                                  };
                              });
                      });
                  setModifiedArray(array)
                  return setTableList(dropVal.tableData);
              }
          }
          obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
              if(Object.keys(el, updateForm)){
              //   if(!isEmpty(dropVal[el])){
                  if(updateForm[el].elementType == 'select' && el !== 'po_number'){
                      updateForm[el].elementConfig.options = dropVal[el];
                      if(props.title === "Delivery" && cookies.get("customer_id") === "17"){
                        updateForm[el].value = dropVal[el][0].value
                      }
                      if((!cromptonDelivery)){
                          updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                        }
                      if (props.title === "User") {
                          if (!(dynamicParam.location_type_id == updateForm['location_type_id'].value)) {
                              updateForm['location_id'].value = null
                          } else {
                              updateForm['location_id'].value = +dynamicParam.location_id
                          }
                      }
                      if(updateForm[el].validate.required === false){
                          updateForm[el].value =  null
                          if(updateForm[el].elementConfig.options[0].displayValue !== "Please Select"){
                              updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                            }
                            updateForm[el].elementConfig.options = dropVal[el]
                      }
  
                      /*To Render value Dynamically within Parent field in Feature Management Feature in Feature Module*/
                      if(updateForm[el].elementConfig.hasOwnProperty('type') &&
                      updateForm[el].elementConfig.type == 'static2') {
                      updateForm[el].value = props.val2
                      }
                      /*To Render value Dynamically within Parent field in Feature Management Feature in Feature Module*/
                  }
                  else if(updateForm[el].elementType == 'multiselect') {
                      updateForm[el].value =  null
                      if(props.title === 'QC Params' || props.title === 'QC Attributes'){
                          let mappedOptions = dropVal[el].reduce((locations, value, id) => {
                              locations.push({ value: id+1, label: value.label });
                              return locations;
                          }, [])
                          if(dynamicParam.transactioncategory == FormVal['transactioncategory']?.value.label){
                              updateForm[el].value = dynamicParam.qc_params
                          }
                      updateForm[el].elementConfig.options = mappedOptions;
                      }
                      else{
                      updateForm[el].elementConfig.options = dropVal[el];
                      }
                 }
                 else if(updateForm[el].elementType == 'selectshowlabel') {
                          updateForm[el].elementConfig.options = dropVal[el];
                          updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
              }
              else if(updateForm[el].elementType == 'selectshowsearch'){
                  updateForm[el].value =  null
                  if(props.title === 'QC Params' || props.title === 'QC Attributes'){
                      let mappedOptions = dropVal[el].reduce((locations, value, id) => {
                          locations.push({ value: id+1, label: value.label });
                          return locations;
                      }, [])
                      if(dynamicParam.transactioncategory == FormVal['transactioncategory']?.value.label){
                          updateForm[el].value = dynamicParam.qc_params
                      }
                  updateForm[el].elementConfig.options = mappedOptions;
                  }else{
                  updateForm[el].elementConfig.options = dropVal[el];
                  }
              }
              }
          })
          setModalformValues(updateForm);
          }
      } catch (error) {
        setHasError({
            error: true,
            message: error
          })
      }
    }


      const handleToggle = () => {
          if (toggle === "Batch Id*") {
              setToggle("Reference Id*");
        }
        if (toggle === "Reference Id*") {
            setToggle("Batch Id*");
        }
      };


       let  clearUnBindValue = () => {
        setUnBindValue('')
      }
      
      useEffect(() => {
        try {
            Object.keys(ModalformValues).forEach((el) => {
                if (props.title === 'Buffer Serial Number' && ModalformValues['po_number'].value !== null) {
                        if (el === 'po_number' && (tableList.length === 1 || tableList.length > 1)) {
                        setPO_number(prev => [...prev, ModalformValues[el].value?.value])
                    }
                }
            })
        } catch (error) {
            setHasError({
                error: true,
                message: error
              })
        }
    }, [props.title, (tableList.length && ModalformValues['po_number']?.value)])

    useEffect(() => {
        const updateForm = {
            ...ModalformValues
        }
        if ("po_number" in updateForm) {
            updateForm.po_number.value = props.uniquePO
        }
        setModalformValues(updateForm)
    }, [props.uniquePO])
    
    const customFormValues = (formValues) => {
        try {
            const customInputFields = Object.keys(formValues)
                .filter(key => ['Primary - Gift Box Quantity', 'product', 'Quantity','material','qty'].includes(key))
                .map(key => ({ name: key, value: formValues[key].value }));
            return customInputFields;
        } catch (error) {
            setHasError({
                error: true,
                message: error
              })
        }
    }

    async function submitForm(event) {
        try{
        event.preventDefault();   
        if(props.commonTitle=='New Notification' || props.commonTitle=='New Template')
        {
            if (validator.allValid()) { 
                swal(`${t("alerts.successfully_submitted")}`, {
                    icon: "success",
                    timer: 2000,
                    button: false
                });
                props.hide();
            }else{
                showValidationMessage(true);
            }

        } else if (props.commonTitle == 'UnBind Serial Number') {
            setDisabled(true)
            let response;
            if (validator.allValid()) {
                let unbindData = {
                    iot: unBindValue,
                    type: unBind.toggle ? "Gift Box" : "Master Carton"
                }
                switch (unBind.delimiter) {
                    case 'multiline':

                        if ((/^([A-Za-z0-9]{11}\n)*[A-Za-z0-9]{11}$/).exec(unBindValue) == null) {
                            swal({
                                title: `${t("alert.11-digit_alpha-numeric_newline")}`,
                                icon: "warning",
                                button: `${t("alerts.ok")}`
                            })
                            setDisabled(false)
                        }
                        else {
                            unbindData = {...unbindData, iot : unBindValue.replace(/\n/g, ",")}
                            response = await PostAPI(props.unBindUrl, unbindData)
                            handleNetworkErrors(response, setHasError);
                        }
                        break;
                    case 'comma':
                        if ((/^[a-zA-Z0-9]{11}(?:,[a-zA-Z0-9]{11})*$/gi).exec(unBindValue) == null) {
                            swal({
                                title: `${t("alert.11-digit_alpha-numeric")}`,
                                icon: "warning",
                                button: `${t("alerts.ok")}`
                            })
                            setDisabled(false)
                        }
                        else {
                            response = await PostAPI(props.unBindUrl, unbindData)
                            handleNetworkErrors(response, setHasError);
                        }
                        break;
                }
                if (response) {
                    if (response?.data.data.status === 200) {
                        swal(response.data.data.message, {
                            icon: "success",
                            timer: 2000,
                            button: `${t("alerts.ok")}`
                        })
                        setDisabled(false)
                        props.recallMehod();
                        props.hide();
                        setUnBindValue('')
                    } else {
                        setDisabled(true)
                        swal(response?.data.data.message, {
                            icon: "warning",
                            button: `${t("alerts.ok")}`
                        })
                        setDisabled(false)
                    }
                }
            }
            else {
                setDisabled(false)
                showValidationMessage(true);
            }
        }

         else {
            if(validator.allValid()){
            if((props.table === true && props.commonTitle == 'AttributeSets' && props.titlePreFix == `${t('edit')}`)) {
            if (((parentTableLength == 0 && ModalformValues.location.value != '' 
                && ModalformValues.product_group.value != '') ||
                (parentTableLength > 0 && productgroup && location)) && 
                (props.table === true && props.commonTitle == 'AttributeSets'
                && props.titlePreFix == `${t('edit')}`)) {
                    return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        }
         if((props.table === true && (props.commonTitle == 'Delivery' || props.commonTitle == 'Reclamation Delivery') && props.titlePreFix == t("add"))) {
            if (((parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.material.value != '' && ModalformValues.qty.value != ''))) {
                 return swal({title:`${t("alerts.add_table")}`,
                              text:`${t("alerts.add_values")}`,
                              icon:"warning",
                              button:`${t("alerts.ok")}`
                }) 
            }
            else{
                const requiredFields = customFormValues(ModalformValues)
                if (requiredFields.every((el) => Boolean(el.value) !== false)) {
                    return swal({ title: `${t("alerts.add_table")}`,
                                  text: `${t("alerts.add_values")}`,
                                  icon: "warning",
                                  button: `${t("alerts.ok")}` 
                    })
                }
                else if (requiredFields.some((el) => Boolean(el.value) == true)) {
                    return addTableAlerts(ModalformValues)
                }
            }
        setloadSForm(false);
        }
        if((props.table === true && props.commonTitle == "Download IOT's(Buffer)")) {
        if (
            ((parentTableLength == 0  && ModalformValues.material.value != '' 
            && ModalformValues.qty.value != ''))
            ) {
                 return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && (props.commonTitle == "Vendor Serial Number" || props.commonTitle == 'Reclamation PO') && 
        props.titlePreFix == `${t('add')}`)) {
        if (
            ((parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.po_number.value != '' 
            && ModalformValues.use_type.value != '')  
             && 
            (props.table === true && (props.commonTitle == "Vendor Serial Number" || props.commonTitle == 'Reclamation PO')
            && props.titlePreFix == `${t('add')}`)
            )) {
                 return swal({title:`${t("alerts.po")}`, text:`${t("alerts.fetch")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && props.commonTitle == 'Pick List' && props.titlePreFix == `${t('add')}`)) {
        if (
            parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.deliveries.value != '' 
            && ModalformValues.from_location.value != '')  
            {
                 return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && (props.commonTitle == "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") && 
        props.titlePreFix == `${t('add')}`)) {
        if (
            parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.transaction.value != '' 
            && ModalformValues.sequence.value != '')  
            {
                 return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && props.commonTitle == "Revert Assigned Serial Number" && props.titlePreFix == `${t('add')}`)) {
            if (parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.product.value != ''){
                 return swal({title:`${t("alerts.add_table")}`,
                              text:`${t("alerts.add_values")}`,
                              icon:"warning",
                              button:`${t("alerts.ok")}`
                            }) 
            }
            else{
                const requiredFields = customFormValues(ModalformValues);
                if (requiredFields.every((el) => Boolean(el.value) !== false)) {
                    return swal({ title: `${t("alerts.add_table")}`,
                                  text: `${t("alerts.add_values")}`,
                                  icon: "warning",
                                  button: `${t("alerts.ok")}` 
                    })
                }
                else if (requiredFields.some((el) => Boolean(el.value) == true)) {
                    return addTableAlerts(ModalformValues)
                }
            }   
            setloadSForm(false);
        }
        if((props.table === true && props.commonTitle == "Assign Serial Number" || props. commonTitle == 'Reclamation Assign PO' || props.title == "Buffer Serial Number" &&  props.titlePreFix == `${t('add')}`)) {
            if (parentTableLength == 0 && props.uniqueid === undefined ){
                return swal({title:`${t("alerts.add_table")}`,
                             text:`${t("alerts.add_values")}`, 
                             icon:"warning", 
                             button:`${t("alerts.ok")}`
                }) 
            }
            else{
                const requiredFields = customFormValues(ModalformValues);
                if (requiredFields.every((el) => Boolean(el.value) !== false)) {
                    return swal({ title: `${t("alerts.add_table")}`,
                                  text: `${t("alerts.add_values")}`,
                                  icon: "warning",
                                  button: `${t("alerts.ok")}` 
                    })
                }
                else if (requiredFields.some((el) => Boolean(el.value) == true)) {
                    return addTableAlerts(ModalformValues)
                }
            }
            setloadSForm(false);
        }
        // if((props.table === true && props.commonTitle == 'Price' && 
        // props.titlePreFix == 'Edit')) {
        // if ((!ModalformValues.Price.value)
        // && (!ModalformValues.Remarks.value)
        // && (!ModalformValues.Remarks.ApplicableFrom)) {
        //     return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
        // }
        // }          
        setloadSForm(true);
        if(props.titlePreFix === `${t('import')}` && selectedFile === undefined) {
            setloadSForm(false);
            return swal({title:`${t("alerts.upload_file")}`, text:`${t("alerts.upload_file_mandotory")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
        }
        if(selectedFile || props.title === "Global Settings") {
            data = new FormData(); 
            data.append('file', selectedFile)
            Object.hasOwn(ModalformValues,'ware_id') && data.append('ware_id',ModalformValues["ware_id"].value)
            data.append('customer_id',cookies.get('customer_id'));
            data.append('user_id',cookies.get('user_id'));
            data.append('language',localStorage.getItem('i18nextLng') === 'en' ? 'english' : 'chinese')
            data.append('userLocation_id',cookies.get("userLocation_id"));
            if(props.title === "Global Settings"){
                let arrayConvert = []
                      if(Array.isArray(ModalformValues["username"].value)) {
                        ModalformValues["username"].value.map(function(fValue, indexId){
                        arrayConvert[indexId] = fValue.value;
                      })
                    }
                data.delete("user_id");
                Object.hasOwn(ModalformValues,'type') && data.append('type',ModalformValues["type"].value)
                data.append('location_id',ModalformValues["locations"].value)
                data.append('user_id',arrayConvert)
            }
            if(ModalformValues['table'])
                data.append('table',ModalformValues['table'].value);
            if(ModalformValues['action'])
                data.append('action',ModalformValues['action'].value);
        }   
        let searchFormDataModified={
            ...commonParams
        };
        let DeliveryExtraParameters = {}
        let revertExtraParameters={}
        for(let inputIdentifier in ModalformValues) {
            if(ModalformValues[inputIdentifier].elementType === 'checkbox') {
                if(ModalformValues[inputIdentifier].value === 0){            
                    searchFormDataModified[inputIdentifier] = false
                }
                else if(ModalformValues[inputIdentifier].value === 1){ 
                    searchFormDataModified[inputIdentifier] = true
                }
                else{
                    searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value;
                }
            }
            if (customerID.includes(cookies.get("customer_id")) && props.commonTitle === 'Delivery' && ModalformValues[inputIdentifier].elementType === 'selectshowsearch') {
                if (ModalformValues[inputIdentifier].value != null) {
                    searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value.value
                    if (unique) {
                        let materialDataArray = [];
                        unique.forEach((tbRes) => {
                            if (inputIdentifier === 'material') {
                                ModalformValues[inputIdentifier].elementConfig.options.forEach((material) => {
                                    if (material.label === tbRes.material) {
                                        tbRes['product_id'] = material.value;
                                    }
                                })
                            }
                            materialDataArray.push(tbRes)
                        });

                        DeliveryExtraParameters = {
                            customer_type: cookies.get('customer_type'),
                            extra_id: props.extraId,
                            tbData: materialDataArray,
                            address: address,
                            city: city,
                            area: area,
                            state: state,
                            country: country,
                            latitudtableDataArraye: mapPosition.lat == null ? lat : mapPosition.lat,
                            longitude: mapPosition.lng == null ? lan : mapPosition.lng,
                            url: completeURL
                        }
                    }
                }
            }
            else if( props.commonTitle ==='Revert Assigned Serial Number' && ModalformValues[inputIdentifier].elementType === 'selectshowsearch' ) {
                    //    For setting po_number data
                   if(inputIdentifier == 'po_number'){
                    searchFormDataModified[inputIdentifier] = [ModalformValues[inputIdentifier].value]

            }
            //    For setting product and tbData(extraparameters) data
            if(unique){
                let tableDataArray = [];
                let productArray = [];
                unique.forEach((tbRes)=>{
                    if(inputIdentifier === 'product'){
                        ModalformValues[inputIdentifier].elementConfig.options.forEach((product)=>{
                            if(product.label === tbRes.product){
                                productArray.push(product);
                                tbRes['pid']= product.value;
                                tableDataArray.push(tbRes)

                            }
                        })
                    }
                });
                
            revertExtraParameters= {
                    customer_type: cookies.get('customer_type'),
                    extra_id:props.extraId,
                    tbData:tableDataArray,
                    address: address,
                    city: city,
                    area: area,
                    state: state,
                    country: country,
                    latitude:  mapPosition.lat == null ? lat : mapPosition.lat,
                    longitude: mapPosition.lng == null ? lan : mapPosition.lng,
                    url: completeURL
                } 
                    
                    searchFormDataModified['product'] = productArray
                }
                }
            else if (ModalformValues[inputIdentifier].elementType === 'selectshowsearch') {
                if ((ModalformValues[inputIdentifier].value) && props.titlePreFix === `${t('edit')}` && Array.isArray(ModalformValues[inputIdentifier].value)) {
                    ModalformValues[inputIdentifier].value.map(function (fValue, indexId) {
                        if (props.title === 'QC Params') {
                            searchFormDataModified['qc_params'] = ModalformValues['qc_params'].value.label
                        }
                         else {
                            searchFormDataModified[inputIdentifier] = fValue.value;
                        }
                    })
                }
                else if ((ModalformValues[inputIdentifier].value)) {
                    searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value.value;
                    if(props.title === 'QC Attributes'){
                        searchFormDataModified = {...dynamicParam, ...commonParams}
                    }
                }
                else {
                    searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value;
                }
            }
            else if(ModalformValues[inputIdentifier].elementType === 'multiselect') {
                if((ModalformValues[inputIdentifier].value)) {
                    let arrayConvert = [];
                    ModalformValues[inputIdentifier]?.value.map(function(fValue, indexId){
                        if(props.title === 'QC Params' || props.title === 'QC Attributes'){
                            arrayConvert[indexId] = fValue.label;
                        }else{
                            arrayConvert[indexId] = fValue.value;
                        }
                    });
                     searchFormDataModified[inputIdentifier] = arrayConvert;
                 }
             }
             else {
                 searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value;
                 if(ModalformValues[inputIdentifier].elementType === "asyncSelect"){
                    let val;
                    if(ModalformValues[inputIdentifier]?.value){
                        if(Array.isArray(ModalformValues[inputIdentifier]?.value)){
                           val = ModalformValues[inputIdentifier]?.value[0].value
                        }else{
                            val = ModalformValues[inputIdentifier]?.value.value
                        }
                    }else val =  ModalformValues[inputIdentifier]?.value
                    searchFormDataModified = {
                        ...searchFormDataModified,
                        [`${inputIdentifier}`]: val
                    }
                }
                //  if (props.commonTitle === 'IOT Bulk Download' && inputIdentifier === 'Quantity') {
                //      if (parseInt(searchFormDataModified[inputIdentifier]) > 10000) {
                //          setloadSForm(false)
                //          return swal({
                //              title: 'Download Limit Exceeded',
                //              text: 'You cannot download more than 10,000 IOTs at once. Please download them in smaller batches consecutively.',
                //              icon: "info",
                //              button: `${t("alerts.ok")}`,
                //          })
                //      }
                //  }
             }
             if (props.commonTitle === "Product Transaction") {
                 if (JSON.parse(JSON.stringify(cloneformValues) !== JSON.stringify({}))) {
                     let value = cloneformValues[inputIdentifier]?.value
                     if (typeof value === 'object' && value !== null && !Array.isArray(value))
                         searchFormDataModified[inputIdentifier] = cloneformValues[inputIdentifier].value.value;
                     else
                         searchFormDataModified[inputIdentifier] = cloneformValues[inputIdentifier].value;
                 }
             }           
         }
         let extraParameters ;
        if(props.commonTitle ==='Revert Assigned Serial Number' ){
            extraParameters = revertExtraParameters;
        }
        if(cookies.get("customer_id") === '14' && props.commonTitle ==='Delivery'){
            extraParameters = DeliveryExtraParameters;
        } else{
            if(props.title ==='Buffer Serial Number'){
                unique =  unique.map(e=>{
    
                    
                    let eee ={}
                        let keys =    Object.keys(e);
                    
                        // if()
                        keys.forEach((key)=>{
                            if(key ==="Primary - Gift Box Quantity" ){
                                eee['primary_qty'] = e[key]
                            }else if(key === 'Secondary - Shipper Carton Quantity'){
                                eee['secondary_qty'] = e[key]
                            }
                            else if(key === 'Total Quantity'){
                                eee['qty'] = e[key]
                            }
                            else{
                                eee[key]=e[key]
                            }
    
                        })
                        return eee;
                    //  return   Object.entries(e).map( ([key, val]) => {
                    //         return `${key}:${val}`
                    //       })
                        // if(e==="Primary - Gift Box Quantity"){
                        //     return {"primary_qty":unique[e]}
                        // }
                        // else if(e === 'Secondary - Shipper Ca,rton Quantity'){
    
                        // }else if(e === 'Total Quantity'){
    
                        // }else{
                        //     return e;
                        // }
                    });
            }
            extraParameters = {
                customer_type: cookies.get('customer_type'),
                extra_id:props.extraId,
                tbData: (props.commonTitle === 'Product Transaction' && disabledOnCheck.transaction)
                ? modifiedArray
                : (props.commonTitle === 'Product Transaction' ? uniqueData : unique),
                address: address,
                city: city,
                area: area,
                state: state,
                country: country,
                latitude:  mapPosition.lat == null ? lat : mapPosition.lat,
                longitude: mapPosition.lng == null ? lan : mapPosition.lng,
                url: completeURL
            } 
        }
        for(let key in ModalformValues){
            if(ModalformValues[key].elementType === 'checkbox'){
                if(ModalformValues[key].value){
                    searchFormDataModified[key] = 1
                }else{
                    searchFormDataModified[key] = 0
                } 
            }
        }
        
        if (props.commonTitle === "Entity") {
            searchFormDataModified = {
                ...searchFormDataModified,
                ...(props.titlePreFix === `${t('add')}` 
                    ? { parent_entity_id: props.uniqueid, ware_id: props.wareId }
                    : { id: props.uniqueid }),
                 action_type : props.titlePreFix.toLowerCase(),
                extraParameters
            };
        }
        else if((props.commonTitle === "Hold") && (props.titlePreFix === `${t('add')}`)){
            searchFormDataModified = {
                ...searchFormDataModified,
                toggle_value:toggle,
            extraParameters
            }  
        }
        else if((props.commonTitle === 'Delivery' || props.commonTitle === "Vendor Info") && (props.titlePreFix === `${t('edit')}`)) {
        for(let inputIdentifier in ModalformValues) {
            if(ModalformValues[inputIdentifier].update?.endPoint && props.permission){
                if(searchFormDataModified['material'] !== ModalformValues['material'].value.value){
                searchFormDataModified['material'] = ModalformValues['material'].value;
                }else{
                    let arrayConvert = [];
                    arrayConvert.push(ModalformValues['material'].value)
                    searchFormDataModified['material'] = arrayConvert;
                }
                let from_location = {}
                    Object.keys(form.data).forEach(el => {
                        if (el === 'from_location') {
                            form.data[el].forEach((value) => {
                                from_location = value.value
                            })
                        }
                    })
                let searchForm = {
                    id:props.uniqueid,
                    extra_id:props.extraId,
                    material:searchFormDataModified['material'],
                    qty:searchFormDataModified['qty']
                }
                if(formInputs){
                    searchForm = form.data.hasOwnProperty('from_location') ? { ...searchForm, from_location, ...commonParams }
                : { ...searchForm, po_number:formInputs['po_number'] }
                }
              let getURL = ModalformValues[inputIdentifier].update.endPoint
              let getresponse = await PostAPI(getURL,searchForm);
              handleNetworkErrors(getresponse,setHasError);
              if(getresponse.status === 200 && getresponse.data.data?.message === undefined){
                  searchFormDataModified = {...searchFormDataModified,
                    po_number:formInputs['po_number']}
                  }
                else if (getresponse.data.data.status === 202) {
                    setloadSForm(false);
                    setDisabledButton(false);
                    return swal({
                        html: true,
                        title: `Inventory not available for :\n ${getresponse.data.data.material}`,
                        text: `(Qty : ${parseInt(searchFormDataModified['qty'])}, Inv : ${getresponse.data.data.qty})`,
                        icon: "info",
                        dangerMode: true,
                    })
                }
          else if (getresponse.data.data.status === 409){
       
            setloadSForm(false);
            setDisabledButton(false);
               return swal(t(getresponse.data.data.message), {
                  icon: "error",
                button:`${t("alerts.ok")}`
                 // timer: 2000,
                 // button: false
              });
          }
            }
            if(ModalformValues[inputIdentifier].elementType === 'selectshowsearch' && Array.isArray(ModalformValues[inputIdentifier].value)) {
                        ModalformValues[inputIdentifier].value.map(function(fValue, indexId){
                            searchFormDataModified[inputIdentifier] = fValue.value;
                            searchFormDataModified = {
                                ...searchFormDataModified,
                                id:props.uniqueid,
                                extraParameters    
                            }
            })
            }else{
                if (inputIdentifier === 'material'){
                    if(typeof searchFormDataModified[inputIdentifier] === 'object'){
                    searchFormDataModified[inputIdentifier].map((material) => {
                        searchFormDataModified[inputIdentifier] = material.value
                    })
                }
            }
            searchFormDataModified = {
                ...searchFormDataModified,
                line:props.line,
                id:props.uniqueid,
                extraParameters    
                }
            }
        }
    }
     else if ((props.commonTitle === "Parent Category") &&(props.titlePreFix === `${t('edit')}`)){
        extraParameters ={
            ...extraParameters,
            extra_id:props.uniqueid,
                
        }
        searchFormDataModified = {
                ...searchFormDataModified,
                id:props.uniqueid,
                extraParameters    
                }
            }
    else if((props.commonTitle === "Download Serial Number" || props.commonTitle == 'Download Reclamation PO')){
        searchFormDataModified = {
                ...searchFormDataModified,
                id:props.uniqueid,
                extraParameters    
        }
    }else if(props.title === "Loyalty Redeem"){
        searchFormDataModified = {
            ...searchFormDataModified,
            loyalty_wallet_transaction_id: props.loyaltyRedeem?.loyaltytransactionid,
            loyalty_wallet_id: props.loyaltyRedeem?.loyaltyWalletId
        }
    }else if((props.title === "Product Type")){
        searchFormDataModified = {
                ...searchFormDataModified,
                lookup_category:"Product Types",
        }
    }else if(props.title === 'IOT Bulk Download' && !(cookies.get('userRole_name') === 'Super Admin')) {
        let defaultValue
        form.data['vendorId'].map((fvalue,id) => {
            defaultValue = fvalue.value
        })
        searchFormDataModified = {
            ...searchFormDataModified,
            vendorId:defaultValue,
    }
    }else if((props.title === "UOM")){
        searchFormDataModified = {
                ...searchFormDataModified,
                manufacture_id: + `${cookies.get("customer_id")}`
        }
    }else if((props.title === 'Assign IOT For BU') && (props.titlePreFix === `${t('edit')}`)){
        searchFormDataModified = {
            ...searchFormDataModified,
            edit_flag:true,
            id:props.uniqueid,
            extraParameters    
    }
    }
     else if(props.commonTitle === 'Buffer Serial Number'){
        searchFormDataModified = {
            ...searchFormDataModified, 
            id:props.uniqueid,
            mode:props.mode,
            extraParameters
        }
    }else if (props.commonTitle === "Generate IOT"){
        searchFormDataModified = {
            ...searchFormDataModified, 
            qty: Number(searchFormDataModified.qty)   
        }
    }else if (props.commonTitle === "Location" && !customerID.includes(cookies.get("customer_id"))){
        if(props.titlePreFix === `${t('edit')}`){
            searchFormDataModified =  {
                ...searchFormDataModified,
                id:props.uniqueid,
                extraParameters
            }
        }else{
            let keyValueArray = Object.entries(searchFormDataModified);
            let filteredArray = keyValueArray.filter(([key,value]) => key !== 'whitelist_ip')
            let updatedObject = Object.fromEntries(filteredArray) 
            searchFormDataModified = disabledOnCheck.whiteList ? {...searchFormDataModified,
                id:props.uniqueid,
                extraParameters} : 
                {...updatedObject, id:props.uniqueid, extraParameters}
            }
    }
    else if(props.commonTitle === 'Product Transaction'){
        searchFormDataModified = {
            ...commonParams,
            active: searchFormDataModified['active'],
            product_id: searchFormDataModified['products'],
            ...(searchFormDataModified['transaction'] !== '' && {transaction: searchFormDataModified['transaction']?.toString()}),
            ...(searchFormDataModified['sequence'] !== '' && {sequence: searchFormDataModified['sequence']?.toString()}),
            location_id: searchFormDataModified['location'],
            id:props.uniqueid,
            extraParameters    
            }
        } else if (props.commonTitle === "Transaction Groups") {
            if (props.titlePreFix === "Edit") {
                searchFormDataModified = {
                    ...searchFormDataModified,
                    selectedTransactions: selectedElements,
                    id: props.uniqueid
                }
            } else {
                searchFormDataModified = {
                    ...searchFormDataModified,
                    selectedTransactions: selectedElements
                }
            }
        }
        else if (props.commonTitle === "Field"){
            if (customFormData.fieldType === "select" && customFormData.selectedOptions?.length < 2) {
                swal("Please add atleast one option.")
                return;
            }
            const samplePayload =
            {
                [`${customFormData.fieldName}`]:
            {
                elementType: customFormData.fieldType === "text" ? "input" : customFormData.fieldType,
                elementConfig: {
                    type: customFormData.fieldType,
                    placeholder: customFormData.label,
                    options: customFormData.selectedOptions?.length > 1 ? customFormData.selectedOptions : undefined
                },
                id: customFormData.fieldName,
                value: null,
                label: `${customFormData.label}${customFormData.isRequired ? "*" : ""}`,
                validate: {
                    required: customFormData.isRequired ? true : false,
                    rules: rule,
                    type: customFormData.regex ? "regex" : undefined,
                    message: customFormData.regex ? customFormData.regexMessage : undefined
                },
                update: {
                    required: customFormData?.dependencyInput ? true : false,
                    endpoint: customFormData?.dependencyInputFieldRule
                }
            }
            }
            searchFormDataModified = {
                ...samplePayload,
                field_data: {
                    fieldName: customFormData.fieldName,
                    fieldType: customFormData.fieldType,
                    label: customFormData.label,
                    showColumn: customFormData.showColumn,
                    isRequired: customFormData.isRequired,
                    optionsField: customFormData.optionsField,
                    validationRule: customFormData.validationRule,
                    regex: customFormData.regex,
                    regexMessage: customFormData.regexMessage,
                    showColumn: customFormData.showColumn,
                    selectedOptions: customFormData.selectedOptions,
                    duplicateOptions: customFormData.duplicateOptions
                },
                id: props.titlePreFix === "Edit" ? props.uniqueid : undefined
            }
        }
    else if(props.commonTitle === "Transaction"){
        searchFormDataModified = {
            ...searchFormDataModified,
            id: props.uniqueid
        }
    }
    else {
            searchFormDataModified = {
                ...searchFormDataModified,
                id:props.uniqueid,
                extraParameters    
                }
        }
        // if (parentTableLength == 0 && props.commonTitle == 'Delivery') {
        //     swal(t("table.add_table"), "Please add item", "warning") 
        //     setloadSForm(false);
        // }
        let formData = new FormData();
        if(props.title === 'Build/Software' || props.title === "Build"){   
            handleFormSubmit()
        }
        if (validator.allValid()&& !props.buildValue) {
            const isGenerateIOT = props.title === "Generate IOT"
            isGenerateIOT ? setDisabledButton(false): setDisabledButton(true);
            if(props.addURL == undefined) {
                setloadSForm(false);
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 1000,
                    button: false
                });
            }
            let response;
            let getdrpdwnresponseJson1
            if(selectedFile || props.title === "Global Settings")
                {
                    response = await PostAPI(props.addURL, data);
                    handleNetworkErrors(response,setHasError);
                }
            else if(props.commonTitle === "Download Buffer IOT's"  || props.commonTitle ==="Download Serial Number" || props.commonTitle == "Download Reclamation PO" || props.commonTitle == "IQC EXCEPTIONAL REJECTED"){
                let getURL = (`${props.addURL}&reason=${reason}`);
                response =  await FetchAPI(getURL);
                handleNetworkErrors(response,setHasError);
                getdrpdwnresponseJson1 = await response.json();
                if(getdrpdwnresponseJson1.data.hasOwnProperty('data')){ 
                    swal(`${t("alerts.successfully_submitted")}`, {
                        icon: "success",
                        timer: 2000,
                        button: false
                    });
                    props.recallMehod();
                    props.hide();
                    window.location.href = getdrpdwnresponseJson1.data.data
                }
                else if(getdrpdwnresponseJson1.data.hasOwnProperty('status')){
                    if (getdrpdwnresponseJson1?.data?.status === 1) {
                            swal({ icon: "success", title: "Success", text: getdrpdwnresponseJson1.data.message })
                            props.recallMehod();
                            props.hide();
                        } else {
                            swal({ icon: "error", title: "Something went wrong!" })
                        }
                    }
                else if(getdrpdwnresponseJson1.data.status === 409){
                    swal(getdrpdwnresponseJson1.data.message, {
                        icon: "warning",
                        //  timer: 2000,
                        // buttton: false
                    })
                }
                else{
                    swal(`${t("alerts.something_went_wrong")}`, {
                        icon: "error",
                       timer: 2000,
                       button: false
                       });
                    }
            }
            else if (props.commonTitle === "Assign Serial Number" ||
                    props.commonTitle === "Assign Buffer Serial Numbers" ||
                    props.commonTitle === 'Vendor Serial Number'||
                    props.commonTitle === 'IOT Bulk Download'
                ) {
                try {
                    PostAPI(props.addURL, searchFormDataModified)
                    .then(res => {
                        if(res.data.data.status === 1){
                            let customText = "Once completed, it will be added to the grid table";

                            if (props.commonTitle === 'Vendor Serial Number'||
                                props.commonTitle === "IOT Bulk Download") {
                                customText = "Please wait for 5 minutes while we prepare your data for download.";
                            }
                            swal({
                                title: `Your ${props.commonTitle} request is being processed`,
                                text: customText,
                                icon: "info",
                                closeOnEsc: false,
                                closeOnClickOutside: false,
                            })
                                .then((willProceed) => {
                                    if (willProceed) {
                                        props.recallMehod();
                                        props.hide();
                                    }
                                    else {
                                        setDisabledButton(false)
                                    }
                                })
                        }else{
                            setDisabledButton(false);
                            swal({
                                text: res.data.data.message,
                                icon: "warning"
                            })
                        }
                    })
                    }
                 catch {
                    swal(`${t("alerts.something_went_wrong")}`, {
                        icon: "error",
                        timer: 2000,
                        button: false
                    });
                    setDisabledButton(false)
                }
            }
            else if(props.commonTitle === 'Delivery' && props.extraId !== 'Reclamation PO' && props.uniqueid !== undefined && props.titlePreFix === `${t('add')}`){
            for(let inputIdentifier in ModalformValues) {
                if(ModalformValues[inputIdentifier].update?.endPoint){
                        if((ModalformValues["material"].value)) {
                            let arrayConvert = [];
                            arrayConvert.push(ModalformValues['material'].value)
                            searchFormDataModified['material'] = arrayConvert;
                        }
                    let searchForm = {
                        id:props.uniqueid,
                        extra_id:props.extraId,
                        material:searchFormDataModified['material'],
                        qty:searchFormDataModified['qty']
                    }
                    let postData = {...searchForm,
                        po_number:form.data['po_number']
                    }
                  let getURL = ModalformValues[inputIdentifier].update.endPoint
                  let getresponse = await PostAPI(getURL,postData);
                  handleNetworkErrors(getresponse,setHasError);
                  if(getresponse.status === 200 && getresponse.data.data?.message === undefined){
                      searchFormDataModified = {...searchFormDataModified,
                        po_number:form.data['po_number']}
                           response = await PostAPI(props.addURL, searchFormDataModified);
                           handleNetworkErrors(response,setHasError);
                         setloadSForm(false);
                    if(isEmpty(response)) {
                         setloadSForm(false);
                         swal(`${t("alerts.something_went_wrong")}`, {
                         icon: "error",
                        timer: 2000,
                        button: false
                        });
                    }
                    else {
                        swal(`${t("alerts.successfully_submitted")}`, {
                            icon: "success",
                            timer: 2000,
                            button: false
                        });
                        setDisabledButton(true);
                    }
                }
                  else if (getresponse.data.data.status === 409 ||getresponse.data.data.status === 0){
                      setloadSForm(false);
                    setDisabledButton(false);
                       return swal(t(getresponse.data.data.message), {
                          icon: "error",
                      button:`${t("alerts.ok")}`
                         // timer: 2000,
                         // button: false
                      });
                  }
                }
                }
            }
            else if(isGenerateIOT || cromptonAssignIot){
                if(props.isIOT){
                    searchFormDataModified = {
                        ...searchFormDataModified,
                        IOTQty: cromptonAssignIot ? props.availableIOTs : undefined ,
                    }
                }
                let getBusinessUnit;
                if(cromptonAssignIot){
                    getBusinessUnit = form.data.businessUnit.filter(record => record.value == searchFormDataModified.businessUnit)[0];
                }
                const span = document.createElement("span");
                span.innerHTML = `Do you want to ${searchFormDataModified.generateInstant ? "generate IOTs instantly" : "proceed"} with ${cromptonAssignIot ? `Business Unit`: "Order Number"} <h5 style="display:inline">${cromptonAssignIot ? getBusinessUnit.displayValue : searchFormDataModified.po_number}</h5> and Quantity <h5 style="display:inline" >${searchFormDataModified.qty}</h5> ?`;
                swal( {
                    html: true,
                    title: `${searchFormDataModified.generateInstant ? "Instantly Generate IOTs ?" : "Are you sure ?"}`,
                    content: span,
                    buttons: ['Cancel', 'Proceed'],

                }).then(async(willProceed) => {
                    if(willProceed){
                    setloadSForm(true)
                    setDisabledButton(true)
                    response = await PostAPI(props.addURL, searchFormDataModified);
                    handleNetworkErrors(response,setHasError);
                    if(cromptonAssignIot && response?.data?.data?.status === 1){
                        swal({
                            title: `Your ${props.commonTitle} request is being processed`,
                            text: "Once completed, it will be added to the grid table",
                            icon: "info",
                            closeOnEsc: false,
                            closeOnClickOutside: false,
                        })
                        .then((willProceed) => {
                            if (willProceed) {
                                    props.recallMehod();
                                    props.hide();
                                }
                                else {
                                    setDisabledButton(false)
                                  }
                            })   
                            return;                 
                    }else if(response.data.data.status == 1){
                        setloadSForm(true)
                        swal(`${t("alerts.successfully_submitted")}`, {
                        icon: "success",
                        timer: 2000,
                        button: false
                    })
                    props.recallMehod();
                    props.hide();
                }else if(response.data.data.status == 409){
                    swal(`${t(response.data.data.message)}`, {
                        icon: "warning",
                        buttons: t('alerts.ok'),  
                }) 
                setloadSForm(false)
                setDisabledButton(false)  
                }else{
                    swal(`${t("alerts.something_went_wrong")}`, {
                        icon: "error",
                        timer: 2000,
                        button: false
                    });
                }
                    }else{
                        setloadSForm(false)
                        setDisabledButton(false)  
                    }
                })
            } else if (props.title === "Transaction Groups") {
                if (searchFormDataModified.selectedTransactions?.length < 1) {
                    setloadSForm(false);
                    setDisabledButton(false);
                    getStatusAlert({
                        status: 0,
                        message: "Please select atleast one transaction"
                    });
                    return;
                } else {
                    response = await PostAPI(props.addURL, searchFormDataModified);
                    handleNetworkErrors(response,setHasError);
                    if (response.status === 200) {
                        getStatusAlert({
                            status: response?.data?.data?.status,
                            message: response?.data?.data?.message,
                            reCallGrid: props.recallMehod,
                            hide: props.hide
                        });
                        setloadSForm(false);
                        setDisabledButton(false);
                    }
                    return;
                }
            }
            else{
                if(props.title == "Location Type"){
                    setloadSForm(false)
                    setLoading(true)
                }
                if(cromptonDownloadIot){
                    let isDownloadQty = true;
                    let isDownloadable = true;
                    let downloadIotExtraPayload = {};
                    if(dropdownApiData?.final_products !== null && dropdownApiData?.final_products?.length > 0){
                        dropdownApiData.final_products.forEach(option => {
                            if(searchFormDataModified?.final_products == option.value){
                                downloadIotExtraPayload["line_item_no"] = option?.line_item_no;
                                downloadIotExtraPayload["product_id"] = option?.product_id
                                if(Number(searchFormDataModified?.qty) > Number(option.qty)){
                                    setloadSForm(false);
                                    setDisabledButton(false);
                                    swal({
                                        title: `Quantity not available.`,
                                        text: `Available quantity for ${option.displayValue} is ${option.qty}`,
                                    })
                                    isDownloadQty = false;
                                }
                                if(option.is_iot_downloadable === 0){
                                    isDownloadable = false;
                                }
                                
                            }
                            searchFormDataModified = {
                                ...downloadIotExtraPayload,
                                ...searchFormDataModified
                            }
                        })
                        if(!isDownloadQty){
                            return;
                        };
                        if(!isDownloadable){
                            setloadSForm(false);
                            setDisabledButton(false);
                            swal("Oops! The IOTs for this product cannot be downloaded")
                            return;
                        };
                    }
                }
                if(props.isIOT){
                    searchFormDataModified = {
                        ...searchFormDataModified,
                        IOTQty: cromptonAssignIot ? props.availableIOTs - props.assignedProcess : undefined ,
                    }
                }
                if(props.commonTitle === "Returns"){
                    searchFormDataModified = {
                        ...searchFormDataModified,
                        id: props.extraId,
                        is_approved: props.isApproved
                    }
                }
                response = await PostAPI(props.addURL, searchFormDataModified);
                handleNetworkErrors(response,setHasError);
                if (props.commonTitle === "Returns") {
                    if (response.status === 200) {
                        if (response.data.Status === 1) {
                            swal(response.data.Message, {
                                icon: "success",
                            });
                            setloadSForm(false)
                            props.hide();
                            props.recallMehod();
                        }else if(response.data.Status === 0){
                            setDisabledButton(false);
                            swal(response.data.Message === "{}" ? "Something went wrong!" : response.data.Message, {
                                icon: "warning",
                            });
                        }
                    }
                    else {
                        swal(`${t("alerts.something_went_wrong")}`, {
                            icon: "error",
                            timer: 2000,
                            button: false
                        });
                        setDisabledButton(false);
                    }
                    setloadSForm(false);
                    return;
                }
                if(props.title=="Password" && response.data.data.status==400 ){
                  
                        swal(`${t(response.data.data.message)}`, {
                        icon: "warning",
                        buttons: t('alerts.ok'),
                    
                })   
                setloadSForm(false);
                setLoading(false)

                return
                }
                // if(props.commonTitle === "Download IOT's(Buffer)"){
                //     window.location.href = response.data.data.data
                // }
            setloadSForm(false);
            if(isEmpty(response)) {
                setloadSForm(false);
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 2000,
                    button: false
                });
            }
        }
            if((response?.status == 200) && (props.commonTitle !== "Download Buffer IOT's" && props.commonTitle !== "Download Serial Number" && props.commonTitle !== "Download Reclamation PO" && props.commonTitle !== "IQC EXCEPTIONAL REJECTED")){
                if(Object.keys(response.data).length === 1 && response.data.hasOwnProperty('timestamp'))
                {
                    swal({
                        icon: "error",
                        text: "Something went wrong!", 
                       timer: 2000,
                        button: false
                    });  
                }
                else if(props.commonTitle === 'Product Label Mapping' && (response.data.data.status === 200 ||
                    response.data.data.status === 201 )){
                        {swal(response.data.data.message, {
                          icon: "success",
                           timer: 2000,
                          // buttton: false
                           });
                           setDisabledButton(false);
                          }
                          props.recallMehod();
                          props.hide();
                        }
                else if(props.titlePreFix !== `${t('import')}` && response.data.data.status === 409) {
            
                    let msg = response.data.data.message;
                    if(Array.isArray(msg)){
                        const content = document.createElement('div');
                        msg.forEach(message => {
                            const p = document.createElement('p');
                            p.textContent = message;
                            content.appendChild(p);
                        });
                        swal({
                            icon: "warning",
                            content: content,
                            title: "Error"
                        })
                        setDisabledButton(false);
                        setloadSForm(false);
                        return;
                       }
                   
                   alertMessage(msg)
                      setDisabledButton(false);
                      setloadSForm(false);
                     }
                else if(props. title === 'Product Type' || props.title === 'UOM'){
                    if(response.data.data.status === 1){
                        swal(response.data.data.message, {
                            icon: "success",
                            timer: 3000,
                            button: true
                        });
                        setDisabledButton(true);
                        props.recallMehod();
                        props.hide();
                    }
                }
                else if(props.title === 'Assign IOT For BU' && response.data.data.status === 0){
                    if(response.data.data.message){
                        swal((response.data.data.message), {
                            icon: "error",
                            timer: 5000,
                            button:`${t("alerts.ok")}`
                        });
                        setDisabledButton(false);
                    }
                }  
                
                else if (props.title === 'Buffer Serial Number') {
                    const { status, message } = response.data.data;
                    let responseBasedIcon = "warning";
                    switch (status) {
                        case 0:
                            responseBasedIcon = "error";
                            break;
                        case 1:
                            responseBasedIcon = "success";
                            break;
                    }
                    const swalOptions = {
                        icon: responseBasedIcon,
                        ...responseBasedIcon === 'success' && { timer: 3000 },
                        ...responseBasedIcon === 'error' && { button: true },
                    };
                    swal(message, swalOptions);
                    setDisabledButton(true);
                    if (responseBasedIcon === "success") {
                        props.recallMehod();
                        props.hide();
                    }
                }     
                else if(props.commonTitle === 'Vendor Info' && response.data.data.status === 202){
                    setDisabledButton(false);
                    swal((response.data.data.message), {
                        icon: "error",
                        button:`${t("alerts.ok")}`
                       // timer: 2000,
                        //button: false
                    });
                }else if((props.commonTitle ==='BOM' || props.commonTitle ==='BOM Mapping')  && response.data.data.status ===0){
                    setDisabledButton(false);
                    swal((response.data.data.message), {
                        icon: "error",
                        button:`${t("alerts.ok")}`
                    }); 
                }
                else if(props.titlePreFix == `${t('import')}` && response.data.data.status === 409) {
     
                 let msg,msg1;
                    if(response.data.data.message.length > 1) {
                        msg = response.data.data.message;
                        // msg1 =msg.split(",Import").join("\nImport")

if(typeof(msg)==="object"){

  msg1=  msg.map((e)=>{
                                return t(e.trim())
                            }).toString()
                        }
                        else if (msg.includes('(')) {
                            let leadingMsg = msg.split("(");
                            let tralingMsg = leadingMsg[1].split(")");
                            let centerMsg = tralingMsg[0].split(',').map((e) => t(e.trim())).join(",")
                            let errorMsg = `${t(leadingMsg[0].trim())} ( ${centerMsg} ) ${t(tralingMsg[1].trim())}`
                            msg1 = t(errorMsg)
                    
                        }
                        else{
                        msg1 = msg.split(",Import").join("\nImport")
                        }

                    } else 
                    {
                        msg1 = response.data.data.message[0]
                    }


                    swal((msg1), {
                        icon: "error",
                        text: t(msg1), 
                        button:`${t("alerts.ok")}`
                       // timer: 2000,
                        //button: false
                    });
                   // setSelectedFile();
                    props.hide();
                    props.recallMehod();
                }
                else {
                    swal(`${t("alerts.successfully_submitted")}`, {
                        icon: "success",
                        timer: 2000,
                        button: false
                    });
                    setDisabledButton(true);
                    if(props.featureTitle == 'Location')
                    props.extracall();
                    props.recallMehod();
                    props.hide();
                   
                }
            }         
            else if(props.commonTitle === "Buffer Serial Number" || props.commonTitle === "Vendor Serial Number" || props.commonTitle == 'Reclamation PO')  {
                setDisabledButton(false)
                if(response?.data?.data?.status === 409 || response?.data?.data?.status === 0){
                    swal(response?.data?.data?.message, {
                        icon: "error",
                        // timer: 2000,
                        button: true
                        });
                }
                else if(response?.data?.data?.status === 1){
                swal(response?.data?.data?.message, {
                    icon: "success",
                    timer: 3000,
                    button: true
                });
                props.recallMehod();
                props.hide();
            }
            else if(response?.data?.data?.hasOwnProperty('message') === undefined){
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 2000,
                    button: false
                    });
            }    
            }
            else {
                setloadSForm(false);
                if(reason == undefined){
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 2000,
                    button: false
                    });
                }
                // props.hide();
            }
        }
        else {
            showValidationMessage(true);
            setloadSForm(false);
        }
        return false;
        }
    else{
            showValidationMessage(true);
        }
    }
    } catch (e) {
        setHasError({
          error: true,
          message: e
        })
      }
}


    async function setActiveTab(e) {
        try {
            let response
            setloadSForm(true);
            commonParams ={...commonParams,
                ...(props.commonTitle === "Global" && {type : selectedType})
            }
            const commanParamVal = new URLSearchParams(commonParams);
            if(props.commonTitle === "Global" && props.titlePreFix === 'Edit'){
                if(Object.hasOwn(formInputs, 'downloadSample')){
                    let url = Domain + '/' + formInputs.downloadSample.slice(7)
                    window.location.href = (`${url}`)
                    setloadSForm(false);
                }else{
                    swal({title:`${t("Oops..! Something went wrong.")}`,
                        icon:"warning",
                        buttons: `${t('alerts.ok')}`,
                         dangerMode: true,
                    })
                }
            }else{
            let URL = props.formValue.downloadSample.update?.endPoint
            let getURL = (`${URL}?${commanParamVal}`);
              response =  await FetchAPI(getURL);
              handleNetworkErrors(response,setHasError);
              if (response.status == 200){
                  setloadSForm(false);
                  let getdrpdwnresponseJson1 = await response.json();
                  let url = Domain + '/' + getdrpdwnresponseJson1.data.slice(7)
                  window.location.href = (`${url}`)
              }
              else{
                swal({title:`${t("Oops..! Something went wrong.")}`,
                icon:"warning",
                buttons: `${t('alerts.ok')}`,
                 dangerMode: true,
            })
            }}
        } catch (error) {
            setHasError({
                error: true,
                message: error
              })
        }
    }
    /*this function is used to set the widths of form fields*/
    const setDynamicFieldWidth = (field) => {
        const { title } = props;
        if (title === "Generate IOT") {
          switch (field) {
            case "order_no":
            case "qty":
              return cookies.get("customer_id") === "17" ? "6" : "5";
            case "generateInstant":
            case "sap_status":
              return "2";
            default:
              return "6";
          }
        }
      
        return "6";
      };

    return (
        <div>
            <div>
            <form>
            <Modal key="ModalK" size="lg"show={props.showModal} onHide={props.hide}
            dialogClassName={props.modalWidth} 
            backdrop="static" keyboard={false} className="modal-custom">
            <span className="close-icon-custom" onClick={props.hide}>
                &times;
            </span>
                    <Modal.Header key="MHeader" className="modal-header-custom">
                    <Modal.Title key="MTitle"> {(props.commonTitle === 'AttributeSets' && props.title1 !== '')  ? props.title1 :  props.titlePreFix}&nbsp;
                        {props.title}
                    </Modal.Title>
                </Modal.Header>
                        <Modal.Body key="MBody">
                            {props.commonTitle === 'Hold' ? (
                                <label>
                                    <span
                                        id="textSpan"
                                        style={
                                            toggle === "Reference Id*"
                                                ? { fontWeight: 'normal' }
                                                : { fontWeight: 'bold', marginTop: "-7px" }
                                        }
                                    >
                                        {toggle === "Reference Id*" ? "Batch Id*" : toggle}
                                    </span>{" "}
                                    {" "}
                                    <Toggle
                                        className="custom-classname"
                                        icons={false}
                                        checked={toggle === "Reference Id*"}
                                        onChange={handleToggle}
                                    />
                                    {" "}
                                    <span
                                        id="textSpan"
                                        style={
                                            toggle === "Batch Id*"
                                                ? { fontWeight: 'normal' }
                                                : { fontWeight: 'bold' }
                                        }
                                    >
                                        {toggle === "Batch Id*" ? "Reference Id*" : toggle}
                                    </span>
                                    <br></br>
                                    <br></br>
                                </label>
                            ) : ''}

                            {(loadSForm) && (
                                <div className='beatLoader-centered'>
                                    <div className='spanLoading'>
                                        <span>Loading...</span>
                                    </div>
                                    <BeatLoader />
                                </div>
                            )}

                            <div className="grid-container">
                                <div className={props.table === true ? "partition-border" : ""}>
                                    <div className="input-fields-container">
                                        {titlesList.includes(props.title) === true && customModalFields(formElementsArray)}

                                        {titlesList.includes(props.title) !== true &&
                                            formElementsArray.map((formElement) => {
                                                if (formElement.config.elementType === "maps") {
                                                    return null; // Skip map element for now to render it separately at the end
                                                }
                                                return (
                                                    (formElement.id !== 'template' &&
                                                        formElement.config.elementType !== "textareaMoreHeight" &&
                                                        formElement.config.elementType !== "checkbox") ? (
                                                        <div
                                                            className="grid-item"
                                                            style={
                                                                formElement.id === 'batch_id'
                                                                    ? { gridColumn: '1 / span 2', marginInlineStart: '-53rem' }
                                                                    : formElement.id === 'description' && props.title === 'Product Type'
                                                                        ? { gridColumn: '1 / span 2', height: '107px', transform: 'translateY(20px)' }
                                                                        : { height: '107px' }
                                                            }
                                                            key={formElement.id}
                                                        >
                                                            <InputField
                                                                key={formElement.id}
                                                                elementType={formElement.config.elementType}
                                                                elementConfig={formElement.config.elementConfig}
                                                                value={formElement.config.value == null ? '' : formElement.config.value}
                                                                labelName={formElement.config.label}
                                                                id={formElement.config.id}
                                                                isValidate={formElement.config.validate}
                                                                changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                                                validater={validator}
                                                                titlePreFix={props.titlePreFix}
                                                                disabledOnCheck={disabledOnCheck}
                                                                title={props.title}
                                                                sequence={sequence}
                                                                setSequence={setSequence}
                                                                transaction={transaction}
                                                                setTransaction={setTransaction}
                                                                readonly={readonly}
                                                                template={props.dyn_template}
                                                                passVal={passVal}
                                                                setPassVal={setPassVal}
                                                                tableList={tableList}
                                                                fileUpload={fileUpload}
                                                                material={material}
                                                                setMaterial={setMaterial}
                                                                dropDownData = {props.titlePreFix === 'Edit' ? formInputs: form?.data}
                                                                qty={qty}
                                                                setQty={setQty}
                                                                toggle={toggle}
                                                                quantity={quantity}
                                                                setQuantity={setQuantity}
                                                                fromDate={fromDate}
                                                                setFromDate={setFromDate}
                                                                toDate={toDate}
                                                                setToDate={setToDate}
                                                                location={location}
                                                                setLocation={setLocation}
                                                                product={product}
                                                                setProduct={setProduct}
                                                                productgroup={productgroup}
                                                                setProductgroup={setProductgroup}
                                                                price={price}
                                                                setPrice={setPrice}
                                                                remarks={remarks}
                                                                setRemarks={setRemarks}
                                                                qtyValidation={props?.qtyValidation}
                                                                setHasError={setHasError}
                                                                fetchAsyncOptions={fetchAsyncOptions}
                                                            />
                                                            {(props.dyn_template === true && formElement.config.elementType === 'anchor') && (
                                                                <span>
                                                                    <a href="javascript:void(0)" 
                                                                    style={props.commonTitle === "Global" && props.titlePreFix === `${t('add')}`
                                                                          ? {
                                                                              pointerEvents: selectedType ? 'auto' : 'none',
                                                                              color: selectedType ? 'blue' : 'grey',
                                                                              opacity: selectedType ? 1 : 0.6,
                                                                              cursor: selectedType ? 'pointer' : 'not-allowed',
                                                                              textDecoration: 'none',
                                                                            }
                                                                          : undefined
                                                                      }
                                                                    onClick={setActiveTab}>Click to download</a>
                                                                </span>
                                                            )}
                                                        </div>
                                                    ) : formElement.config.elementType === "checkbox" ? (
                                                        <div className="grid-item" style={{ height: '82px' }} key={formElement.id}>
                                                            <InputField
                                                                key={formElement.id}
                                                                elementType={formElement.config.elementType}
                                                                elementConfig={formElement.config.elementConfig}
                                                                value={formElement.config.value == null ? '' : formElement.config.value}
                                                                labelName={formElement.config.label}
                                                                id={formElement.config.id}
                                                                sequence={sequence}
                                                                setSequence={setSequence}
                                                                transaction={transaction}
                                                                disabledOnCheck={disabledOnCheck}
                                                                setTransaction={setTransaction}
                                                                isValidate={formElement.config.validate}
                                                                changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                                                validater={validator}
                                                                titlePreFix={props.titlePreFix}
                                                                title={props.title}
                                                                setHasError={setHasError}
                                                            />
                                                        </div>
                                                    ) : 
                                                         <div className="grid-item_location" key={formElement.id}>
                                                            <InputField
                                                                key={formElement.id}
                                                                elementType={formElement.config.elementType}
                                                                elementConfig={formElement.config.elementConfig}
                                                                value={formElement.config.value == null ? '' : formElement.config.value}
                                                                labelName={formElement.config.label}
                                                                id={formElement.config.id}
                                                                isValidate={formElement.config.validate}
                                                                changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                                                validater={validator}
                                                                titlePreFix={props.titlePreFix}
                                                                disabledOnCheck={disabledOnCheck}
                                                                title={props.title}
                                                                sequence={sequence}
                                                                setSequence={setSequence}
                                                                transaction={transaction}
                                                                setTransaction={setTransaction}
                                                                readonly={readonly}
                                                                template={props.dyn_template}
                                                                passVal={passVal}
                                                                setPassVal={setPassVal}
                                                                tableList={tableList}
                                                                fileUpload={fileUpload}
                                                                material={material}
                                                                setMaterial={setMaterial}
                                                                qty={qty}
                                                                setQty={setQty}
                                                                toggle={toggle}
                                                                quantity={quantity}
                                                                setQuantity={setQuantity}
                                                                fromDate={fromDate}
                                                                setFromDate={setFromDate}
                                                                toDate={toDate}
                                                                setToDate={setToDate}
                                                                location={location}
                                                                setLocation={setLocation}
                                                                product={product}
                                                                setProduct={setProduct}
                                                                productgroup={productgroup}
                                                                setProductgroup={setProductgroup}
                                                                price={price}
                                                                setPrice={setPrice}
                                                                remarks={remarks}
                                                                setRemarks={setRemarks}
                                                                qtyValidation={props?.qtyValidation}
                                                                setHasError={setHasError} />
                                                         </div>
                                                )
                                            })}

                                        {formElementsArray.filter(element => element.config.elementType === "maps").map((mapElement) => (
                                            <div className="grid-item_location" key={mapElement.id}>
                                                <InputField
                                                    elementType={mapElement.config.elementType}
                                                    elementConfig={mapElement.config.elementConfig}
                                                    value={mapElement.config.value == null ? '' : mapElement.config.value}
                                                    labelName={mapElement.config.label}
                                                    id={mapElement.config.id}
                                                    isValidate={mapElement.config.validate}
                                                    changed={(event) => inputModalChangedHandler(event, mapElement.id)}
                                                    validater={validator}
                                                    address={address}
                                                    city={city}
                                                    area={area}
                                                    sequence={sequence}
                                                    setSequence={setSequence}
                                                    transaction={transaction}
                                                    setTransaction={setTransaction}
                                                    state={state}
                                                    country={country}
                                                    lat={lat}
                                                    lan={lan}
                                                    mapPosition={mapPosition}
                                                    markerPosition={markerPosition}
                                                    setAddress={setAddress}
                                                    setLat={setLat}
                                                    setLan={setLan}
                                                    setCity={setCity}
                                                    setArea={setArea}
                                                    setState={setState}
                                                    setCountry={setCountry}
                                                    setMapPosition={setMapPosition}
                                                    setMarkerPosition={setMarkerPosition}
                                                    center={center}
                                                    setHasError={setHasError}         
                                                />
                                            </div>
                                        ))}

                {(props.title === "Build/Software" || props.title === "Build") && <Col>
                    {(props.title === "Build/Software" || props.title === "Build" || props.titlePreFix === 'Edit') ?
                        <div>  
                            <Row>
                                <Col md="3"></Col>
                                    <label for="build" style={{ fontWeight: 300, color: "black",marginTop:'14px' }}>Release Build/Software*</label>
                                    <FileUpload setMultiUploadFiles={setMultiUploadFiles}setUploadFiles={setUploadFiles} editResponse = {formInputs} editHandler = {editHandler} titlePreFix = {props.titlePreFix} buildInputVal={buildInputVal}
                                        setBuildUrl={setBuildUrl} setEditFileUpload={setEditFileUpload}  setEditProp={setEditProp} setBuildEdit={setBuildEdit} setChecked={setChecked} ModalformValues={ModalformValues} buildUrl={buildUrl}/>
                                    <FileList uploadFiles={uploadFiles} buildUrl={buildUrl} titlePreFix = {props.titlePreFix} removeFile={removeFile} />
                                    </Row>
                            <Row>
                                <Col md="3"></Col>
                                    <label for="release_notes" style={{ fontWeight: 300, color: "black"}}>Release Notes</label>
                                    <MultiFileUpload multiUploadFiles={multiUploadFiles} setMultiUploadFiles={setMultiUploadFiles}  editHandler = {editHandler} docUrl={docUrl} setDocUrl={setDocUrl}  setEditProp={setEditProp} setDocEdit={setDocEdit} buildInputVal={buildInputVal}/>
                                    <MultiFileList multiUploadFiles={multiUploadFiles} docUrl={docUrl} editResponse = {formInputs} titlePreFix = {props.titlePreFix} removeFile={removeFile} />
                             </Row>
                        </div> : ""
                        }
                                
                    </Col>}
                                    </div>
                                </div>
                            </div>
                            {(props.table === true) && 
                                (
                                    ((props.commonTitle === 'Delivery' || props.title === 'Buffer Serial Number' || props.commonTitle === 'Pick List' || props.commonTitle ==='Revert Assigned Serial Number' || props.commonTitle === "BOM Mapping" ||  props.commonTitle === "Assign Serial Number"  || ((props.commonTitle == 'Product Transaction' && disabledOnCheck.transaction === false))? props.titlePreFix === `${t('add')}` && props.uniqueid === undefined : null) ||
                                      props.commonTitle == "Download IOT's(Buffer)" || props.commonTitle== "AttributeSets" || props.commonTitle== "AttributeSet" || props.commonTitle == "Purchase Order" || props.commonTitle == "Reclamation Assign PO" || props.commonTitle == 'Reclamation Delivery'  || ((props.commonTitle == 'Price'|| (props.commonTitle == 'Product Transaction' && disabledOnCheck.transaction === false)) && (props.titlePreFix === `${t('edit')}`) || props.commonTitle === "BOM Mapping")) ?
                                        <div style={{display:"grid"}}>
                                        {(props.commonTitle == 'Price' && props.titlePreFix == `${t('edit')}`
                                        && unique[0].ApplicableFrom < moment(new Date()).format("YYYY-MM-DD")) 
                                            ? 
                                            <div className="addtable__button">
                                            <button
                                                disabled="true"
                                                onClick={() => addTableData(ModalformValues)}
                                                className="btnCls"
                                                style={{
                                                    backgroundColor: buttonBackgroundColor,
                                                    color: buttonTextColor,
                                                    fontSize:'initial'
                                                }}
                                            >
                                            </button>
                                        </div>
                                        :
                                        <div className="addtable__button">
                                            {(props.commonTitle === "Revert Assigned Serial Number" ?
                                                <button 
                                                disabled={disabled}
                                                onClick={ () => addTableData(ModalformValues) }
                                                class="btnCls"
                                                style={{
                                                    backgroundColor: buttonBackgroundColor,
                                                    color: buttonTextColor,
                                                    fontSize: 'initial'
                                                }}
                                                >{`${t('add_table')}`}</button>
                                                :
                                            <button 
                                            onClick={ () => addTableData(ModalformValues) }
                                            class="btnCls"
                                            style={{
                                                backgroundColor: buttonBackgroundColor,
                                                color: buttonTextColor,
                                                fontSize: 'initial'
                                            }}
                                            >{`${t('add_table')}`}</button>
                                            )}
                                        </div>
                                    }
                                            {/* <div className='text-center mb-3 row'>
                                                <button 
                                                onClick={ () => addTableData(ModalformValues) }
                                                class="btn btn-outline-primary btn-rounded waves-effect"
                                                style={{borderRadius: '15px',width: '13%',float:'right',marginRight:'5%'}}
                                                >Add Table</button>
                                            </div> */}
                                        </div>
                                    :'')}
                                    {(props.commonTitle === "Vendor Serial Number" || props.commonTitle === "Reclamation PO" && props.titlePreFix == `${t('add')}` && tableList == 0) ?
                                    <div style={{display:"grid"}}>
                                        <div className="addtable__button">
                                        <button
                                            disabled={disabled}
                                            onClick={() => addTableData(ModalformValues)}
                                            className="btnCls"
                                            style={{
                                                backgroundColor: buttonBackgroundColor,
                                                color: buttonTextColor,
                                                fontSize: 'initial'
                                            }}
                                        >{`${t('fetch_data')}`}
                                        </button>
                                    </div>
                                    </div>: ""}

                             {props.isDragAndDrop &&
                                <DragAndDrop
                                    selectElements={selectElements}
                                    setSelectElements={setSelectElements}
                                    selectedElements={selectedElements}
                                    setSelectedElements={setSelectedElements}
                                />}

                            {unique && unique.length > 0 && (
                                <div className="add__table-container grid-item-fullwidth">
                                    <Table striped hover>
                                        <thead>
                                            <tr>{getHeader()}</tr>
                                        </thead>
                                        <tbody>
                                            {getRowsData()}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                   {(props.title==='Build/Software' && loading===true)&& <div className='beatLoader-centered' ><BeatLoader color={"#3C423C"} /></div>}
                        </Modal.Body>
                        <Modal.Footer key="MFooter">
                                <div className='footer-grid'>
                                    <div className='modal__button-container'>
                                        {(props.titlePreFix === `${t("view")}` && props.commonTitle === 'IOT')
                                            ? ''
                                            : (props.commonTitle === 'Hold') ? (
                                                <ButtonField submit={submitForm} color="primary" BName="Hold" />
                                            ) : (
                                                <ButtonField
                                                    disabled={disabledButton}
                                                    submit={submitForm}
                                                    color="primary"
                                                    BName={
                                                        (props.titlePreFix === `${t('edit')}` ||
                                                         (props.titlePreFix === t("add") && props.commonTitle !== "Vendor Serial Number"))
                                                          ? `${t('save')}`
                                                           : (props.titlePreFix === t("add") && props.commonTitle === "Vendor Serial Number" ||
                                                                props.titlePreFix === t('enter') ||
                                                                props.titlePreFix === t("update") ||
                                                                props.titlePreFix === t("import") ||
                                                                props.commonTitle === "Loyalty Redeem" ||
                                                                props.title === 'UnBind Serial Number' ||
                                                                props.commonTitle === "Download IOT's" ||
                                                                props.commonTitle === "Download IOT's(Buffer)" ||
                                                                props.commonTitle === "Download Buffer IOT's" ||
                                                                props.commonTitle === "Download Serial Number" ||
                                                                props.title === "Download Reclamation PO")
                                                                ? `${t('submit')}`
                                                                : `${t('modal_add')}`
                                                    }
                                                />
                                            )
                                        }
                                        <ButtonField submit={props.title === 'UnBind Serial Number' ? clearUnBindValue : props.hide} color="danger" BName={props.title === 'UnBind Serial Number' ? `${t("clear")}` : `${t('close')}`} />
                                    </div>
                                    {(props.title !=='Build/Software' && loading === true) && <div className='loader-container'><BeatLoader color={"#3C423C"} /></div>}
                                </div>
                        </Modal.Footer>
            </Modal>
            </form>
            </div>
        </div>
    );
}

export default ModalBox;